import React, { useState, useEffect, useRef } from 'react';
import { QRCode } from "react-qrcode-logo";
import QRCode1 from "qrcode";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, Navbar } from "../../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears } from "./../Utils";

import "../../assets/css/bootstrap.min.css";
import "../../assets/css/fontawesome-all.min.css";
import "../../assets/css/slick.css";
import "../../assets/css/line-awesome.min.css";
import "../../assets/css/main.css";
import "../../assets/css/responsive.css";

// Importing assets
import ProfileImage from "../../assets/images/all/Instituteimage.png";
import NotificationIcon from "../../assets/images/icons/notification-bing-svgrepo-com 1.svg";
import qrImage from "../../assets/images/all/qr_code.png";
import EditImage from "../../assets/images/icons/edit-1-svgrepo-com.svg"
import EditIcon from "../../assets/images/icons/edit-4-svgrepo-com 1.svg";
import LocationIcon from "../../assets/images/icons/location-pin-alt-1-svgrepo-com.svg";
import SearchIcon from "../../assets/images/all/search.svg";
import teacherSvg from '../../assets/images/icons/teacehr_+.svg'
import editSvg from '../../assets/images/icons/edit-1-svgrepo-com.svg'
import mediaImage from '../../assets/images/icons/Frame 399.svg'
import StudentSidebar from "../../components/StudentSidebar";
import CommanStudentTeacherHeader from '../../components/CommanStudentTeacherHeader';
import CommanInstitute from '../../components/CommanInstitute';
import CommonInstituteMob from '../../components/CommonInstituteMob';
import DownloadIcon from '../../assets/images/icons/downloads-svgrepo-com 1.svg';

const InstituteProfile = (props) => {

    // console.log(flags);
    const navigate = useNavigate();
    const [brand, setBrand] = useState("");
    const [state, setState] = useState("");
    const [category, setCategory] = useState('');
    const [board, setBoard] = useState('');
    const [standard, setStandard] = useState('');
    const [categories, setCategories] = useState([]);
    const [boards, setBoards] = useState([]);
    const [standards, setStandards] = useState([]);
    const [cities, setCities] = useState([]);
    const [areas, setAreas] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedBoard, setSelectedBoard] = useState('');
    const [selectedStandard, setSelectedStandard] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedArea, setSelectedArea] = useState('');
    const [email, setEmail] = useState('');
    const [placeName, setPlaceName] = useState('');
    const [mobile, setMobile] = useState('');
    const [address, setAddress] = useState('');


    const [editId, setEditId] = useState(null);

    const [city, setCity] = useState('');
    const [area, setArea] = useState('');
    const [legacyList, setLegacyList] = useState([]);
    const [newLegacy, setNewLegacy] = useState({
        title: "",
        name: "",
        image: null,
    });
    const [selectedNewLegacyFile, setSelectedNewLegacyFile] = useState(null);

    const [showOptions, setShowOptions] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFile1, setSelectedFile1] = useState(null);
    const [selectedBrouchureFile, setSelectedBrouchureFile] = useState(null);
    const [profileimg, setProfileimg] = useState(""); // State to hold roles data
    const [profileDataEditable, setprofileDataEditable] = useState(false);
    const [bioInfoEditable, setBioInfoEditable] = useState(false);
    const [OtherInfoEditable, setOtherInfoEditable] = useState(false);
    const [StreamEditable, setStreamEditable] = useState(false);
    const [isSectionOpen, setIsSectionOpen] = useState(false);
    const [isSectionOpen1, setIsSectionOpen1] = useState(false);
    const [facilty, setFacility] = useState("")
    const [showExpert, setShowExpert] = useState([])
    const [profileData, setProfileData] = useState({
        full_name: "",
        email_id: "",
        username: "",
        location: "",
    });
    const [managers, setManagers] = useState([]);
    const [bioInfo, setBioInfo] = useState({
        bio_info: "",
    });

    const [otherInfoDetails, setOtherInfoDetails] = useState({
        no_of_students_studyind: "",
        year_of_establishment: "",
        timings: "",
        hostels: "",
        approved_by: "",
        affiliation: "",
        gender_composition: "",
    });
    const [streamDetails, setStreamDetails] = useState({
        stream_name: '',
        fee: '',
        year: '',
        stream_bio: '',
    });
    const [streamDetails1, setStreamDetails1] = useState([]);
    const [facilitydata, setFacilityData] = useState([])
    const [isEditable2, setIsEditable2] = useState(false);
    const [managerDetails2, setManagerDetails2] = useState({
        fullName: "",
        email: "",
        phone: "",
        location: "",
    });

    const [editingIndex, setEditingIndex] = useState(null);
    const [streams, setStreams] = useState([]);
    const [editingIndex2, setEditingIndex2] = useState(null);

    const [topperData, setTopperData] = useState({
        topper_name: "",
        exam: "",
        rank: "",
        image: null, // Store image file
    });

    const [legacyData, setLegacyData] = useState({
        title: "",
        name: "",
        image: null, // Store image file
    });

    // const [expertData, setExpertData] = useState({
    //     expert_name: "",
    //     rank: "",
    //     image: null, // Store image file
    // });

    const [newExpert, setNewExpert] = useState({
        expert_name: "",
        rank: "",
        image: null,
    });

    const [selectedTopperFile, setSelectedTopperFile] = useState(null);
    // const [selectedExpertFile, setSelectedExpertFile] = useState(null);
    const [selectedNewExpertFile, setSelectedNewExpertFile] = useState(null);

    const [selectedLegacyFile, setSelectedLegacyFile] = useState(null);
    const [description, setDescription] = useState("");


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTopperData({
            ...topperData,
            [name]: value,
        });
        // setLegacyData({
        //     ...legacyData,
        //     [name]: value,
        //   });
    };


    const handleNewLegacyChange = (e) => {
        const { name, value } = e.target;
        setNewLegacy({ ...newLegacy, [name]: value });
    };

    const handleNewLegacyFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedNewLegacyFile(file);
        setNewLegacy({ ...newLegacy, image: file });
    };

    const handleExistingLegacyChange = (index, e) => {
        const { name, value } = e.target;
        const updatedLegacyList = [...legacyList];
        updatedLegacyList[index][name] = value;
        setLegacyList(updatedLegacyList);
    };

    const handleExistingLegacyFileChange = (index, e) => {
        const file = e.target.files[0];
        const updatedLegacyList = [...legacyList];
        updatedLegacyList[index].image = file;
        setLegacyList(updatedLegacyList);
    };

    const saveNewLegacy = async () => {
        if (!newLegacy.name || !newLegacy.image) {
            alert("Please fill all fields!");
            return;
        }
        // console.log("newLegacynewLegacy",newLegacy)
        // return false

        const formData = new FormData();
        formData.append("user_id", currentUserId);
        formData.append("description", newLegacy.title);
        formData.append("name", newLegacy.name);
        formData.append("media_image_name", newLegacy.image);
        // formData.append("description", "");

        try {
            const response = await axios.post(`${API_BASE_URL}/createSterlingResultsMediaFile/null`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status === "success") {
                alert("Legacy details saved successfully!");
                setNewLegacy({ title: "", name: "", image: null });
                setSelectedNewLegacyFile(null);
                fetchLegacyData();
            }
        } catch (error) {
            console.error("Error saving legacy data:", error);
            alert("Failed to save legacy data.");
        }
    };

    const toggleEditLegacy = (index) => {
        const updatedLegacyList = [...legacyList];
        updatedLegacyList[index].isEditing = !updatedLegacyList[index].isEditing;
        setLegacyList(updatedLegacyList);
    };

    const saveExistingLegacy = async (index) => {
        const legacy = legacyList[index];
        console.log("dfbfnfbfnb", legacy)
        // return false
        const formData = new FormData();
        formData.append("user_id", currentUserId);
        formData.append("description", legacy.description);
        formData.append("name", legacy.name);
        if (legacy.image) formData.append("media_image_name", legacy.image);

        try {
            const response = await axios.post(`${API_BASE_URL}/createSterlingResultsMediaFile/${legacy.id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status === "success") {
                alert("Legacy data updated successfully!");
                toggleEditLegacy(index);
            }
        } catch (error) {
            console.error("Error updating legacy data:", error);
            alert("Failed to update legacy data.");
        }
    };

    // const handleInputChange1 = (e) => {
    //     const { name, value } = e.target;
    //     setExpertData({
    //         ...expertData,
    //         [name]: value,
    //     });

    // };

    const handleNewExpertChange = (e) => {
        const { name, value } = e.target;
        setNewExpert({ ...newExpert, [name]: value });
    };

    const handleNewExpertFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedNewExpertFile(file);
        setNewExpert({ ...newExpert, image: file });
    };

    const handleExistingExpertChange = (index, e) => {
        const { name, value } = e.target;
        const updatedExperts = [...showExpert];
        updatedExperts[index][name] = value;
        setShowExpert(updatedExperts);
    };

    const handleExistingExpertFileChange = (index, e) => {
        const file = e.target.files[0];
        const updatedExperts = [...showExpert];
        updatedExperts[index].image = file;
        setShowExpert(updatedExperts);
    };

    const saveNewExpert = async () => {
        if (!newExpert.expert_name || !newExpert.rank || !newExpert.image) {
            alert("Please fill all fields!");
            return;
        }

        const formData = new FormData();
        formData.append("user_id", currentUserId);
        formData.append("name", newExpert.expert_name);
        formData.append("rank", newExpert.rank);
        formData.append("description", "");
        formData.append("media_image_name", newExpert.image);

        try {
            const response = await axios.post(`${API_BASE_URL}/createMeetOurExpertTeamMediaFile/null`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status === "success") {
                alert("Expert added successfully!");
                setNewExpert({ expert_name: "", rank: "", image: null });
                setSelectedNewExpertFile(null);
                fetchExpertData(); // Refresh the expert list
            }
        } catch (error) {
            console.error("Error adding expert:", error);
            alert("Failed to add expert.");
        }
    };

    const toggleEditMode = (index) => {
        const updatedExperts = [...showExpert];
        updatedExperts[index].isEditing = !updatedExperts[index].isEditing;
        setShowExpert(updatedExperts);
    };

    const saveExistingExpert = async (index) => {
        const expert = showExpert[index];
        console.log("expert data will be", expert)
        // return false
        const formData = new FormData();
        formData.append("user_id", currentUserId);
        formData.append("name", expert.name);
        formData.append("rank", expert.rank);
        if (expert.image) formData.append("media_image_name", expert.image);

        try {
            const response = await axios.post(`${API_BASE_URL}/createMeetOurExpertTeamMediaFile/${expert.id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status === "success") {
                alert("Expert updated successfully!");
                toggleEditMode(index);
            }
        } catch (error) {
            console.error("Error updating expert:", error);
            alert("Failed to update expert.");
        }
    };

    const handleSaveBrand = () => {
        console.log("Saved Brand:", brand);
    };

    const handleSaveState = () => {
        console.log("Saved State:", state);
    };

    const handleInputChange3 = (e) => {
        const { title, name, value } = e.target;
        setLegacyData({
            ...legacyData,
            [name]: value,
        });

    };


    const handleExpertFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedExpertFile(file);
        setExpertData((prev) => ({ ...prev, image: file }));
    };

    const handleLegacyFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedLegacyFile(file);
        setLegacyData((prev) => ({ ...prev, image: file }));
    };

    const handleTopperFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedTopperFile(file);

        setTopperData({
            ...topperData,
            image: file, // Store file in state
        });
    };

    // Save Topper Data to Database

    const saveExpert = async () => {
        console.log("expertDataexpertData", expertData)
        // return false
        if (!expertData.expert_name || !expertData.rank || !expertData.image) {
            alert("Please fill all fields!");
            return;
        }

        const formData = new FormData();
        formData.append("user_id", ACCESS_Log_In_User_Id());
        formData.append("role_id", ACCESS_Role_ID());
        formData.append("name", expertData.expert_name);
        formData.append("rank", expertData.rank);
        formData.append("description", "");
        formData.append("media_image_name", expertData.image); // Upload image file

        try {
            const response = await axios.post(`${API_BASE_URL}/createMeetOurExpertTeamMediaFile/null`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status == 'success') {
                alert("Expert details saved successfully!");
                setTopperData({ topper_name: "", exam: "", rank: "", image: null });
                setSelectedTopperFile(null);
            }
        } catch (error) {
            console.error("Error saving topper:", error);
            alert("Failed to save topper data.");
        }
    };

    const saveTopper = async () => {
        if (!topperData.topper_name || !topperData.exam || !topperData.rank || !topperData.image) {
            alert("Please fill all fields!");
            return;
        }

        const formData = new FormData();
        formData.append("user_id", ACCESS_Log_In_User_Id());
        formData.append("role_id", ACCESS_Role_ID());
        formData.append("topper_name", topperData.topper_name);
        formData.append("exam", topperData.exam);
        formData.append("rank", topperData.rank);
        formData.append("image", topperData.image); // Upload image file

        try {
            const response = await axios.post(`${API_BASE_URL}/saveTopper/${id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.success) {
                alert("Topper details saved successfully!");
                setTopperData({ topper_name: "", exam: "", rank: "", image: null });
                setSelectedTopperFile(null);
            }
        } catch (error) {
            console.error("Error saving topper:", error);
            alert("Failed to save topper data.");
        }
    };

    const saveDescription = async () => {
        if (!description) {
            alert("Please enter a description!");
            return;
        }

        const formData = new FormData();
        formData.append("user_id", ACCESS_Log_In_User_Id());
        // formData.append("role_id", ACCESS_Role_ID());
        formData.append("description", description);
        formData.append("status", "1");

        try {
            const response = await axios.post(`${API_BASE_URL}/createLetsEvolveTheParadigms/null`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status == 'success') {
                alert(response.data.message);
                setDescription("");
            }
        } catch (error) {
            console.error("Error saving description:", error);
            alert("Failed to save description.");
        }

    };

    // Save Topper Data to Database
    const saveLegacy = async () => {
        console.log("dskjsdks", legacyData, ACCESS_Log_In_User_Id())
        // return false
        if (!legacyData.name || !legacyData.image) {
            alert("Please fill all fields!");
            return;
        }

        const formData = new FormData();
        formData.append("user_id", ACCESS_Log_In_User_Id());
        formData.append("role_id", ACCESS_Role_ID());
        formData.append("title", legacyData.title);
        formData.append("name", legacyData.name);
        formData.append("media_image_name", legacyData.image);
        formData.append("description", "");  // Upload image file

        try {
            const response = await axios.post(`${API_BASE_URL}/createSterlingResultsMediaFile/null`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status == 'success') {
                alert("Legacy details saved successfully!");
                setLegacyData({ titile: "", name: "", image: null });
                setSelectedLegacyFile(null);
            }
        } catch (error) {
            console.error("Error saving topper:", error);
            alert("Failed to save legacy data.");
        }
    };



    const handleEditClick5 = (index) => {
        setEditingIndex2(index); // Set the index of the facility being edited
    };

    const handleChange5 = (index, field, value) => {
        const updatedFacilities = facilitydata.map((facility, i) =>
            i === index ? { ...facility, [field]: value } : facility
        );
        setFacilityData(updatedFacilities);
    };

    const handleEditClick4 = (index) => {
        setEditingIndex(index); // Enable edit mode for the selected stream
    };

    const handleChange4 = (index, field, value) => {
        const updatedStreams = streams.map((stream, i) =>
            i === index ? { ...stream, [field]: value } : stream
        );
        setStreams(updatedStreams); // Update the state with modified data
    };

    const handleSave4 = () => {
        setEditingIndex(null); // Exit edit mode
        // Save to backend or perform additional actions here
        console.log("Updated Streams: ", streams);
    };

    const handleInputDescription = (event) => {
        setDescription(event.target.value);
    };


    const user_id = ACCESS_Log_In_User_Id();
    const { id, flags } = useParams();
    const currentUserId = user_id ? user_id : id;

    console.log("Current user id:", currentUserId);
    // console.log("Current user id: "+id);
    const flag = "link";  // Example flag parameter
    const encodedUserId = encodeURIComponent(currentUserId);
    const encodedFlag = encodeURIComponent(flag);
    const profileUrl = `${window.location.origin}/instituteProfile/${encodedUserId}/${encodedFlag}`;
    const dashboardUrl = `${window.location.origin}/InstituteDetail/${encodedUserId}`;

    const urlToShare = dashboardUrl; // URL to be shared
    //const message = "Name: " + profileData.full_name + "   Email Id: " + profileData.email_id;

    useEffect(() => {

        fetchProfile();
        fetchExpertData()
        fetchCategories();
        fetchBoards()
        fetchCities()
        fetchStandards()
        fetchAreas()
        fetchLegacyData()
        fetchMediaFile()
        fetchBioInfoDetails();
        fetchPersonalInfoDetails();
        fetchOtherInfoDetails();
        fetchStreamDetails();
        fetchFacilityDetails();
        GetinstituteManagerPersonalInfo()
    }, []); // Empty dependency array to run only on mount

    const fetchProfile = async () => {
        // const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getprofileImgDetails?user_id=${currentUserId}`)
            .then(function (response) {
                // console.log("profile imahges ssss",response.data.code);
                if (response.data.code == 200) {
                    console.log(response.data.data[0]);
                    setProfileimg(response.data.data[0]);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const fetchStandards = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getFindTheCenterStandards`);
            const data = response.data?.map(item => ({
                ...item,
                isEditing: false,
            })) || [];
            setStandards(data);
        } catch (error) {
            console.error('Error fetching standards:', error);
        }
    };

    const fetchCities = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getFindTheCenterCity`);
            const data = response.data?.map(item => ({
                ...item,
                isEditing: false,
            })) || [];
            setCities(data);
        } catch (error) {
            console.error('Error fetching cities:', error);
        }
    };

    const fetchAreas = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getFindTheCenterArea`);
            const data = response.data?.map(item => ({
                ...item,
                isEditing: false,
            })) || [];
            setAreas(data);
        } catch (error) {
            console.error('Error fetching areas:', error);
        }
    };



    const fetchBoards = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getFindTheCenterBoard`);
            const data = response.data?.map(item => ({
                ...item,
                isEditing: false,
            })) || [];
            setBoards(data);
        } catch (error) {
            console.error('Error fetching boards:', error);
        }
    };


    const toggleEditModeBoard = (index) => {
        setBoards(prev => prev.map((b, i) => i === index ? { ...b, isEditing: !b.isEditing } : b));
    };

    const handleEditInputChangeBoard = (index, value) => {
        setBoards(prev => prev.map((b, i) => i === index ? { ...b, board_name: value } : b));
    };


    // Standard
    const toggleEditModeStandard = (index) => {
        setStandards(prev => prev.map((item, i) => i === index ? { ...item, isEditing: !item.isEditing } : item));
    };
    const handleEditInputChangeStandard = (index, value) => {
        setStandards(prev => prev.map((item, i) => i === index ? { ...item, standard_name: value } : item));
    };

    // City
    const toggleEditModeCity = (index) => {
        setCities(prev => prev.map((item, i) => i === index ? { ...item, isEditing: !item.isEditing } : item));
    };
    const handleEditInputChangeCity = (index, value) => {
        setCities(prev => prev.map((item, i) => i === index ? { ...item, city_name: value } : item));
    };

    // Area
    const toggleEditModeArea = (index) => {
        setAreas(prev => prev.map((item, i) => i === index ? { ...item, isEditing: !item.isEditing } : item));
    };
    const handleEditInputChangeArea = (index, value) => {
        setAreas(prev => prev.map((item, i) => i === index ? { ...item, area_name: value } : item));
    };



    const saveBoard = async (index) => {
        const board = boards[index];
        try {
            const formData = new FormData();
            formData.append('board_name', board.board_name);
            formData.append('user_id', ACCESS_Log_In_User_Id());
            formData.append('role_id', ACCESS_Role_ID());
            formData.append('status', '1');

            await axios.post(`${API_BASE_URL}/createFindTheCenterBoard/${board.id}`, formData);
            alert('Board updated successfully!');
            fetchBoards();
        } catch (error) {
            console.error('Error saving board:', error);
        }
    };

    const deleteBoard = async (index) => {
        const board = boards[index];
        try {
            await axios.delete(`${API_BASE_URL}/deleteFindTheCenterBoardById/${board.id}`);
            alert('Board deleted!');
            fetchBoards();
        } catch (error) {
            console.error('Error deleting board:', error);
        }
    };


    // Standard
    const saveStandard = async (index) => {
        const item = standards[index];
        console.log("===== ===== ====== =====>", item)
        // return false
        try {
            const formData = new FormData();
            formData.append('standard_name', item.standard_name);
            formData.append('user_id', ACCESS_Log_In_User_Id());
            formData.append('role_id', ACCESS_Role_ID());
            formData.append('status', '1');

            await axios.post(`${API_BASE_URL}/createFindTheCenterStandard/${item.id}`, formData);
            alert('Standard updated successfully!');
            fetchStandards();
        } catch (error) {
            console.error('Error updating standard:', error);
        }
    };

    const deleteStandard = async (index) => {
        const item = standards[index];
        try {
            await axios.delete(`${API_BASE_URL}/deleteFindTheCenterStandardsById/${item.id}`);
            alert('Standard deleted!');
            fetchStandards();
        } catch (error) {
            console.error('Error deleting standard:', error);
        }
    };

    // City
    const saveCity = async (index) => {
        const item = cities[index];
        try {
            const formData = new FormData();
            formData.append('city_name', item.city_name);
            formData.append('user_id', ACCESS_Log_In_User_Id());
            formData.append('role_id', ACCESS_Role_ID());
            formData.append('status', '1');

            await axios.post(`${API_BASE_URL}/createFindTheCenterCity/${item.id}`, formData);
            alert('City updated successfully!');
            fetchCities();
        } catch (error) {
            console.error('Error updating city:', error);
        }
    };

    const deleteCity = async (index) => {
        const item = cities[index];
        try {
            await axios.delete(`${API_BASE_URL}/deleteFindTheCenterCityById/${item.id}`);
            alert('City deleted!');
            fetchCities();
        } catch (error) {
            console.error('Error deleting city:', error);
        }
    };

    // Area
    const saveArea = async (index) => {
        const item = areas[index];
        try {
            const formData = new FormData();
            formData.append('area_name', item.area_name);
            formData.append('user_id', ACCESS_Log_In_User_Id());
            formData.append('role_id', ACCESS_Role_ID());
            formData.append('status', '1');

            await axios.post(`${API_BASE_URL}/createFindTheCenterArea/${item.id}`, formData);
            alert('Area updated successfully!');
            fetchAreas();
        } catch (error) {
            console.error('Error updating area:', error);
        }
    };

    const deleteArea = async (index) => {
        const item = areas[index];
        try {
            await axios.delete(`${API_BASE_URL}/deleteFindTheCenterAreaById/${item.id}`);
            alert('Area deleted!');
            fetchAreas();
        } catch (error) {
            console.error('Error deleting area:', error);
        }
    };





    const fetchCategories = async () => {
        // const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getFindTheCenterCategory`)
            .then(function (response) {
                console.log("getFindTheCenterCategory ssss", response.data);
                const data = response.data?.map(item => ({
                    ...item,
                    isEditing: false,
                })) || [];
                setCategories(data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const fetchExpertData = async () => {
        axios.get(`${API_BASE_URL}/getMeetOurExpertTeamMediaFile?user_id=${currentUserId}`)
            .then(response => {
                console.log("response of screen", response.data.data)
                if (response.data.code === 200) {
                    const expertsWithEditFlag = response.data.data.map(expert => ({
                        ...expert,
                        isEditing: false, // Initially, not in edit mode
                        image: null, // Placeholder for image uploads
                    }));
                    setShowExpert(expertsWithEditFlag);
                }
            })
            .catch(error => console.error(error));
    };


    const fetchLegacyData = async () => {
        axios
            .get(`${API_BASE_URL}/getSterlingResultsMediaFile?user_id=${currentUserId}`)
            .then((response) => {
                if (response.data.code === 200) {
                    const updatedLegacyList = response.data.data.map((item) => ({
                        ...item,
                        isEditing: false,
                        image: null, // Placeholder for image uploads
                    }));
                    setLegacyList(updatedLegacyList);
                }
            })
            .catch((error) => console.error(error));
    };

    const fetchMediaFile = async () => {
        const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getinstituteMediaFile/${currentUserId}`)
            .then(function (response) {
                // console.log(response.data.code);
                if (response.data.code == 200) {
                    // console.log("media file will be",response.data.data[0]);

                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const handleEditClick2 = () => {
        setIsEditable2(!isEditable2);
    };

    const handleInputChange2 = (e) => {
        const { name, value } = e.target;
        setManagerDetails2({ ...managerDetails2, [name]: value });
    };

    const shareToFacebook = () => {
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            urlToShare
        )}`;
        window.open(facebookUrl, "_blank");
    };

    // Download QR
    const qrValue = "https://example.com"; // The value encoded in the QR code
    const text = "Scan this QR code!"; // Custom text below QR code
    const canvasRef = useRef(null);
    const generateQR = async () => {
        try {
            const canvas = canvasRef.current;
            if (!canvas) return;

            const qrSize = 200;
            const textHeight = 30; // Space for text

            // Generate the QR code directly onto the canvas
            await QRCode1.toCanvas(canvas, qrValue, { width: qrSize });

            // Get canvas context and add text
            const ctx = canvas.getContext("2d");
            ctx.font = "16px Arial";
            ctx.fillStyle = "black";
            ctx.textAlign = "center";
            ctx.fillText(text, qrSize / 2, qrSize + 20);
        } catch (error) {
            console.error("QR Code Generation Error:", error);
        }
    };

    const canvas = canvasRef.current;
    const headingText = "Padhai Dekho"; // Heading text at the top
    const footerText = "Vidya";
    const handleDownload = async () => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        const qrSize = 200;
        const headingHeight = 40; // Space for heading
        const footerHeight = 40; // Space for footer

        // Set canvas size
        canvas.width = qrSize;
        canvas.height = qrSize + headingHeight + footerHeight;

        // Clear previous drawings
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw background for heading
        ctx.fillStyle = "#3498db"; // Blue background
        ctx.fillRect(0, 0, canvas.width, headingHeight);

        // Draw heading text
        ctx.font = "bold 18px Arial";
        ctx.fillStyle = "white"; // White text
        ctx.textAlign = "center";
        ctx.fillText(headingText, qrSize / 2, 25);

        // Generate QR code onto a temporary canvas
        const tempCanvas = document.createElement("canvas");
        tempCanvas.width = qrSize;
        tempCanvas.height = qrSize;
        await QRCode1.toCanvas(tempCanvas, qrValue, { width: qrSize });

        // Draw QR code below heading
        ctx.drawImage(tempCanvas, 0, headingHeight);

        // Draw background for footer text
        ctx.fillStyle = "#2ecc71"; // Green background
        ctx.fillRect(0, qrSize + headingHeight, canvas.width, footerHeight);

        // Draw footer text
        ctx.font = "bold 16px Arial";
        ctx.fillStyle = "white"; // White text
        ctx.fillText(footerText, qrSize / 2, qrSize + headingHeight + 25);
        // const canvas = canvasRef.current;
        if (!canvas) return;

        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "qrcode.png";
        link.click();
    };

    const shareToWhatsApp = () => {
        const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
            urlToShare
        )}`;
        window.open(whatsappUrl, "_blank");
    };

    const shareToTwitter = () => {
        const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            urlToShare)}`;
        window.open(twitterUrl, "_blank");
    };

    const updateProfileImage = (e) => {
        // alert("gfgfhgf")
        const file = e.target.files[0];
        if (file) {
            setProfileimg(file.name); // Update the profile image with the uploaded file
            // Prepare the FormData object for the POST request
            const formData = new FormData();
            formData.append('profile_image_name', file); // Append the image file to FormData
            formData.append('role_id', ACCESS_Role_ID());
            formData.append('user_id', ACCESS_Log_In_User_Id());

            try {
                // Use FormData in the POST request to send the file correctly
                let id = null;
                if (profileimg && profileimg.hasOwnProperty('id')) {
                    id = profileimg['id'] ?? null;
                }
                axios.post(`${API_BASE_URL}/createUpdateprofileImg/${id}`, formData)
                    .then((response) => {
                        console.log('Profile image uploaded successfully:', response.data);
                        fetchProfile(); // Fetch updated profile info
                    })
                    .catch((error) => {
                        console.error('Error saving profile:', error);
                    });
            } catch (error) {
                console.error('Error in uploading profile:', error);
            }
        }
    };

    const handleFileChange = (e) => {
        // alert("called 21")
        setSelectedFile(e.target.files[0]);
        // setSelectedBrouchureFile(e.target.files[0]);
        // setSelectedTopperFile(e.target.files[0]);
        const file = e.target.files[0];
        setSelectedTopperFile(file);
        // setSelectedLegacyFile(file);
        setTopperData({
            ...topperData,
            image: file, // Store file in state
        });
        // setLegacyData({
        //     ...legacyData,
        //     image: file, // Store file in state
        // });

    };

    const handleFileChange1 = (e) => {
        setSelectedFile1(e.target.files[0]);
        // setSelectedBrouchureFile(e.target.files[0]);
        // setSelectedTopperFile(e.target.files[0]);
        const file = e.target.files[0];
        setSelectedExpertFile(file);

        setExpertData({
            ...expertData,
            image: file, // Store file in state
        });

    };

    const handleUploadClick = () => {
        if (selectedFile) {
            console.log('File selected:', selectedFile);
            updateMediaImage(selectedFile)
            // Add your upload logic here (e.g., API call to upload the file)
        } else {
            alert('Please select a file before uploading.');
        }
    };

    const handleUploadBrouchureClick = () => {
        if (selectedBrouchureFile) {
            console.log('File selected:', selectedBrouchureFile);
            // return false
            davePdfFile(selectedBrouchureFile)
            // Add your upload logic here (e.g., API call to upload the file)
        } else {
            alert('Please select a file before uploading.');
        }
    };

    const updateMediaImage = async (e) => {
        const file = e;

        if (file) {
            // Prepare the FormData object for the POST request
            const formData = new FormData();
            formData.append('media_image_name', file); // Append the image file
            formData.append('media_image_path', ''); // Use empty string instead of null for form data
            formData.append('description', ''); // Same for description
            formData.append('role_id', ACCESS_Role_ID());
            formData.append('user_id', ACCESS_Log_In_User_Id());

            try {
                const id = null; // Define id properly or use dynamic value if needed

                // Perform the POST request
                const response = await axios.post(
                    `${API_BASE_URL}/createinstituteMediaFile/${currentUserId}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data', // Explicitly set content type
                        },
                    }
                );

                // console.log('Institute media uploaded successfully:', response.data);
                // alert("Institute media uploaded successfully")
                fetchMediaFile()
                // Optionally call fetchProfile or other functions here
            } catch (error) {
                console.error('Error saving media:', error.response?.data || error.message);
            }
        } else {
            console.error('No file selected for upload.');
        }
    };

    // Update brouchure pdf
    const updateBrouchurePdf = async (e) => {
        const file = e;

        if (file) {
            // Prepare the FormData object for the POST request
            const formData = new FormData();
            formData.append('media_pdf_name', file); // Append the image file
            formData.append('media_pdf_path', ''); // Use empty string instead of null for form data
            formData.append('role_id', ACCESS_Role_ID());
            formData.append('user_id', ACCESS_Log_In_User_Id());

            try {
                const id = null; // Define id properly or use dynamic value if needed

                // Perform the POST request
                const response = await axios.post(
                    `${API_BASE_URL}/createinstituteMediaFile/${currentUserId}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data', // Explicitly set content type
                        },
                    }
                );

                // console.log('Institute media uploaded successfully:', response.data);
                // alert("Institute media uploaded successfully")
                fetchMediaFile()
                // Optionally call fetchProfile or other functions here
            } catch (error) {
                console.error('Error saving media:', error.response?.data || error.message);
            }
        } else {
            console.error('No file selected for upload.');
        }
    };


    const fetchBioInfoDetails = async () => {
        const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getbioInfoDetails?user_id=${currentUserId}`)
            .then(function (response) {
                //console.log(response);
                if (response.data.code == 200) {
                    // console.log(response.data.data[0]);
                    //setbioInfoDetails(response.data.data[0]);
                    setBioInfo({
                        id: response.data.data[0]["id"],
                        bio_info: response.data.data[0]['bio_info'],
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const BioInfoEdit = async () => {
        if (bioInfoEditable) {
            try {
                const id = bioInfo['id'] ?? null;
                const response = await axios.post(`${API_BASE_URL}/createUpdatebioInfo/${id}`, {
                    user_id: ACCESS_Log_In_User_Id(),
                    role_id: ACCESS_Role_ID(),
                    bio_info: bioInfo.bio_info
                });

                // Assuming the API returns the updated profile data
                // console.log('Profile updated:', response.data);
                // Optionally update the state with the new data
                setProfileData(response.data);
            } catch (error) {
                console.error('Error saving profile:', error);
            }
        }
        // Toggle the edit mode
        setBioInfoEditable(!bioInfoEditable);
        fetchBioInfoDetails();
        fetchPersonalInfoDetails();
    };
    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setBioInfo((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const fetchPersonalInfoDetails = async () => {
        const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getpersonalInfoDetails?user_id=${currentUserId}`)
            .then(function (response) {
                // console.log(response);
                if (response.data.code == 200) {
                    // console.log(response.data.data[0]);
                    //setpersonalInfoDetails(response.data.data[0]);
                    setProfileData({
                        id: response.data.data[0]["id"],
                        full_name: response.data.data[0]["full_name"],
                        email_id: response.data.data[0]["email_id"],
                        username: response.data.data[0]["username"],
                        location: response.data.data[0]["location"],
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const personalInfoEdit = async () => {
        if (profileDataEditable) {
            try {
                // Assuming the API endpoint is 'https://example.com/api/profile'
                const id = profileData['id'] ?? null;
                const response = await axios.post(`${API_BASE_URL}/createUpdatepersonalInfoDetails/${id}`, {
                    user_id: ACCESS_Log_In_User_Id(),
                    role_id: ACCESS_Role_ID(),
                    full_name: profileData.full_name,
                    email_id: profileData.email_id,
                    username: profileData.username,
                    location: profileData.location
                });

                // Assuming the API returns the updated profile data
                // console.log('Profile updated:', response.data);
                // Optionally update the state with the new data
                setProfileData(response.data);
            } catch (error) {
                console.error('Error saving profile:', error);
            }
        }
        // Toggle the edit mode
        setprofileDataEditable(!profileDataEditable);
        fetchPersonalInfoDetails();
        fetchBioInfoDetails();
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfileData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleToggleSection = () => {
        setIsSectionOpen(true);
    };

    const handleToggleSection1 = () => {
        setIsSectionOpen1(!isSectionOpen1);
    };
    /// Other info start

    const fetchOtherInfoDetails = async () => {
        const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getInstitutesOtherDataById/${currentUserId}`)
            .then(function (response) {
                // console.log("Access data field is", response);
                if (response.data.code == 200) {
                    setOtherInfoDetails({
                        id: response.data.data[0]["id"],
                        no_of_students_studyind: response.data.data[0]["no_of_students_studyind"],
                        year_of_establishment: response.data.data[0]["year_of_establishment"],
                        timings: response.data.data[0]["timings"],
                        hostels: response.data.data[0]["hostels"],
                        approved_by: response.data.data[0]["approved_by"],
                        affiliation: response.data.data[0]["affiliation"],
                        gender_composition: response.data.data[0]["gender_composition"],
                    });

                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const CreateUpdateOtherInfoDetails = async () => {
        console.log("otherInfoDetailsotherInfoDetails", otherInfoDetails)
        // return false
        // if (OtherInfoEditable) {
        try {
            const id = null;
            const response = await axios.post(`${API_BASE_URL}/createUpdateInstitutesOtherData/${id}`, {
                user_id: ACCESS_Log_In_User_Id(),
                role_id: ACCESS_Role_ID(),
                no_of_students_studyind: otherInfoDetails.no_of_students_studyind,
                year_of_establishment: otherInfoDetails.year_of_establishment,
                timings: otherInfoDetails.timings,
                hostels: otherInfoDetails.hostels,
                approved_by: otherInfoDetails.approved_by,
                affiliation: otherInfoDetails.affiliation,
                gender_composition: otherInfoDetails.gender_composition,
            });

            // Assuming the API returns the updated profile data
            console.log('Profile updated updateinstatitue dtaa :', response.data);
            // Optionally update the state with the new data
            setOtherInfoDetails(response.data);
        } catch (error) {
            console.error('Error saving profile:', error);
        }
        // }
        // Toggle the edit mode
        setOtherInfoDetails(!OtherInfoEditable);
        fetchBioInfoDetails();
        fetchPersonalInfoDetails();
        fetchOtherInfoDetails();
        fetchStreamDetails();
    };
    const CreateUpdateOtherInfoDetails1 = async (index) => {
        console.log("otherInfoDetailsotherInfoDetails 12333", streams[index])

        try {
            const updatedStream = streams[index];
            const id = streams[index]?.id;
            const response = await axios.post(`${API_BASE_URL}/createUpdateInstitutesStream/${id}`, {
                user_id: ACCESS_Log_In_User_Id(),
                role_id: ACCESS_Role_ID(),
                stream_name: updatedStream.stream_name,
                fee: updatedStream.fee,
                year: updatedStream.year,
                stream_bio: updatedStream.stream_bio,
            });
            // setStreams(response.data)
            setEditingIndex(null); // Exit edit mode
            fetchStreamDetails();

            console.log('Profile updated updateinstatitue dtaa :', response.data);

        } catch (error) {
            console.error('Error saving profile:', error);
        }
        // }
        // Toggle the edit mode
        setOtherInfoDetails(!OtherInfoEditable);
        fetchBioInfoDetails();
        fetchPersonalInfoDetails();
        fetchOtherInfoDetails();
        fetchStreamDetails();
    };


    const handleOtherInfoDetails = (e) => {
        const { name, value } = e.target;
        setOtherInfoDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    /// Other info end

    /// Stream start

    const fetchStreamDetails = async () => {
        try {
            const user_id = ACCESS_Log_In_User_Id();
            const response = await axios.get(`${API_BASE_URL}/getInstitutesStreamById/${currentUserId}`);

            if (response.data.code === 200) {
                // console.log("Access data field is", response);

                // Directly use response data instead of mapping unnecessarily
                const data = response.data.data || []; // Default to an empty array if `data` is undefined
                setStreams(response.data.data);
                setStreamDetails1(data); // Assuming `setStreamDetails1` expects an array
            } else {
                console.log("Error: Unexpected response code", response.data.code);
            }
        } catch (error) {
            console.error("Error fetching stream details:", error);
        }
    };
    const fetchFacilityDetails = async () => {
        try {
            const user_id = ACCESS_Log_In_User_Id();
            const response = await axios.get(`${API_BASE_URL}/getInstitutesFacilitiesById/${currentUserId}`);
            // console.log("dhdhdhhdhd============dddffff",response)
            if (response.data.code === 200) {
                console.log("Access data field is hhhhhh hhh  =======", response);

                // Directly use response data instead of mapping unnecessarily
                const data = response.data.data || []; // Default to an empty array if `data` is undefined
                setFacilityData(data); // Assuming `setStreamDetails1` expects an array
            } else {
                console.log("Error: Unexpected response code", response.data.code);
            }
        } catch (error) {
            console.error("Error fetching stream details:", error);
        }
    }

    const CreateUpdateStreamDetails = async () => {
        try {
            const id = streamDetails['id'] ?? null;
            const response = await axios.post(`${API_BASE_URL}/createUpdateInstitutesStream/${id}`, {
                user_id: ACCESS_Log_In_User_Id(),
                role_id: ACCESS_Role_ID(),
                stream_name: streamDetails.stream_name,
                fee: streamDetails.fee,
                year: streamDetails.year,
                stream_bio: streamDetails.stream_bio,
            });
            setStreamDetails(response.data);
            setIsSectionOpen(false)
            setShowOptions(!isSectionOpen)
        } catch (error) {
            console.error('Error saving profile:', error);
        }
        setStreamDetails(!StreamEditable);
        setIsSectionOpen(false)
        setShowOptions(!isSectionOpen)
        fetchBioInfoDetails();
        fetchPersonalInfoDetails();
        fetchOtherInfoDetails();
        fetchStreamDetails();
    };




    const GetinstituteManagerPersonalInfo = async () => {
        try {
            const user_id = ACCESS_Log_In_User_Id();
            const response = await axios.get(`${API_BASE_URL}/getinstituteManagerPersonalInfo/${currentUserId}`);

            if (response.data.code === 200) {
                // console.log("Access data field is institute789788888888", response);
                setManagers(response.data.data);


            } else {
                // console.log("Error: Unexpected response code", response.data.code);
            }
        } catch (error) {
            console.error("Error fetching stream details:77777777777777777", error);
        }
    };


    const CreateUpdateinstituteManagerPersonalInfo = async () => {
        try {
            const id = managers?.id ?? null; // Replace streamDetails if necessary
            const response = await axios.post(
                `${API_BASE_URL}/createUpdateinstituteManagerPersonalInfo/${id}`,
                {
                    user_id: ACCESS_Log_In_User_Id(),
                    role_id: ACCESS_Role_ID(),
                    full_name: managerDetails2.fullName,
                    femail_id: managerDetails2.email,
                    username: "SampleUsername", // Replace with the correct field
                    phone_no: managerDetails2.phone,
                    location: managerDetails2.location,
                }
            );
            // console.log("Manager updated successfully:", response.data);
            // alert("Manager updated successfully");
            GetinstituteManagerPersonalInfo()
            setIsEditable2(false);
        } catch (error) {
            console.error("Error saving profile:", error);
            alert("Failed to save profile. Please try again.");
        }
    };
    const CreateUpdateInstitutesFacilities = async () => {
        // console.log("jdsjjdjdjsdjdsjdsjjd", facilty)
        // return false
        try {
            const id = streamDetails['id'] ?? null;
            const response = await axios.post(`${API_BASE_URL}/createUpdateInstitutesFacilities/${id}`, {
                user_id: ACCESS_Log_In_User_Id(),
                role_id: ACCESS_Role_ID(),
                facilities_name: facilty,

            });
            if (response.data.code === 200) {
                // console.log("ddddddddddddddd--------", response);

                // Directly use response data instead of mapping unnecessarily
                // const data = response.data.data || []; // Default to an empty array if `data` is undefined
                // setFacilityData(data); // Assuming `setStreamDetails1` expects an array
            } else {
                console.log("Error: Unexpected response code", response.data.code);
            }
            setIsSectionOpen1(!isSectionOpen1)

        } catch (error) {
            console.error('Error saving profile:', error);
        }
        setIsSectionOpen1(!isSectionOpen1)
        fetchBioInfoDetails();
        fetchPersonalInfoDetails();
        fetchOtherInfoDetails();
        fetchStreamDetails();
        fetchFacilityDetails()
    };

    const updateInstitutesFacilities = async (index) => {
        console.log("jdsjjdjdjsdjdsjdsjjd", facilitydata[index])
        // return false
        const updatedFacility = facilitydata[index];
        // return false
        try {
            const id = updatedFacility['id'] ?? null;
            const response = await axios.post(`${API_BASE_URL}/createUpdateInstitutesFacilities/${id}`, {
                user_id: ACCESS_Log_In_User_Id(),
                role_id: ACCESS_Role_ID(),
                facilities_name: updatedFacility?.facilities_name,

            });
            if (response.data.code === 200) {
                console.log("ddddddddddddddd--------5222", response);
                setEditingIndex2(null);
                fetchFacilityDetails();
                // Directly use response data instead of mapping unnecessarily
                // const data = response.data.data || []; // Default to an empty array if `data` is undefined
                // setFacilityData(data); // Assuming `setStreamDetails1` expects an array
            } else {
                console.log("Error: Unexpected response code", response.data.code);
            }
            setEditingIndex2(null);
            fetchFacilityDetails();
            setIsSectionOpen1(!isSectionOpen1)

        } catch (error) {
            console.error('Error saving profile:', error);
        }
        setIsSectionOpen1(!isSectionOpen1)
        fetchBioInfoDetails();
        fetchPersonalInfoDetails();
        fetchOtherInfoDetails();
        fetchStreamDetails();
        fetchFacilityDetails()
    };
    const handleStreamDetails = (e) => {
        const { name, value } = e.target;
        setStreamDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const [branches, setBranches] = useState([{ name: "", contact_number: "", email_id: "", address: "" }]);

    const addBranch = () => {
        setBranches([...branches, { name: "", contact_number: "", email_id: "", address: "" }]);
    };

    const handleChange6 = (index, event) => {
        const newBranches = [...branches];
        newBranches[index][event.target.name] = event.target.value;
        setBranches(newBranches);
    };

    const davePdfFile = async (file) => {
        const formData = new FormData();
        formData.append("user_id", ACCESS_Log_In_User_Id()); // Ensure this function exists
        formData.append("role_id", ACCESS_Role_ID()); // Ensure this function exists
        formData.append("media_image_name", file, file.name); // File name added for clarity

        try {
            const response = await fetch(`${API_BASE_URL}/createDownloadBrochureFile/null`, {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                const errorText = await response.text(); // Get error response text
                throw new Error(`Upload failed: ${errorText}`);
            }

            const result = await response.json();
            alert(result.message);
            console.log("Uploaded File URL:", result);
        } catch (error) {
            console.error("Error uploading file:", error);
            alert(`File upload failed: ${error.message}`);
        }
    }

    const handleFileChange12 = async (event) => {
        const file = event.target.files?.[0]; // Optional chaining to avoid errors

        if (!file) {
            alert("No file selected.");
            return;
        }

        if (file.type !== "application/pdf") {
            alert("Only PDF files are allowed!");
            event.target.value = ""; // Reset file input
            return;
        }

        setSelectedBrouchureFile(file); // ✅ Update UI with selected file


    };


    const saveBranches = async () => {
        try {
            const response = await axios.post(`${API_BASE_URL}/branches/${id}`, {
                branches: branches,
                user_id: ACCESS_Log_In_User_Id(),
                role_id: ACCESS_Role_ID(),
            });
            alert(response.data.message);
        } catch (error) {
            console.error("Error saving branches:", error);
        }
    };


    const validateField = (fieldValue, fieldName) => {
        if (!fieldValue.trim()) {
            alert(`Please enter ${fieldName}`);
            return false;
        }
        return true;
    };

    const handleSaveCategory = async () => {
        // alert(category)
        // return false
        if (!validateField(category, 'Category')) return;

        try {
            const formData = new FormData();
            formData.append("categoty_name", category);
            formData.append("user_id", ACCESS_Log_In_User_Id());
            formData.append("role_id", ACCESS_Role_ID());
            formData.append("status", "1");

            const response = await axios.post(
                `${API_BASE_URL}/createFindTheCenterCategory/null`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            alert(response.data.message || 'Category saved!');
            setCategory('');
            fetchCategories();
        } catch (error) {
            console.error("Error saving category:", error);
            alert('Error saving category');
        }
    };



    const handleSaveBoard = async () => {
        if (!validateField(board, 'Board')) return;
        try {
            const formData = new FormData();
            formData.append("board_name", board);
            formData.append("user_id", ACCESS_Log_In_User_Id());
            formData.append("role_id", ACCESS_Role_ID());
            formData.append("status", "1");

            const response = await axios.post(`${API_BASE_URL}/createFindTheCenterBoard/null`, formData);
            alert(response.data.message || 'Board saved!');
            setBoard('');
            fetchBoards()
        } catch (error) {
            console.error("Error saving board:", error);
            alert('Error saving board');
        }
    };

    const handleSaveStandard = async () => {
        if (!validateField(standard, 'Standard')) return;
        console.log("daraafafa", standard)
        // return false
        try {
            const formData = new FormData();
            formData.append("standards_name", standard);
            formData.append("user_id", ACCESS_Log_In_User_Id());
            formData.append("role_id", ACCESS_Role_ID());
            formData.append("status", "1");

            const response = await axios.post(`${API_BASE_URL}/createFindTheCenterStandards/null`, formData);
            alert(response.data.message || 'Standard saved!');
            fetchStandards()
            setStandard('');
        } catch (error) {
            console.error("Error saving standard:", error);
            alert('Error saving standard');
        }
    };

    const handleSaveCity = async () => {
        if (!validateField(city, 'City')) return;
        try {
            const formData = new FormData();
            formData.append("city_name", city);
            formData.append("user_id", ACCESS_Log_In_User_Id());
            formData.append("role_id", ACCESS_Role_ID());
            formData.append("status", "1");

            const response = await axios.post(`${API_BASE_URL}/createFindTheCenterCity/null`, formData);
            alert(response.data.message || 'City saved!');
            setCity('');
            fetchCities()
        } catch (error) {
            console.error("Error saving city:", error);
            alert('Error saving city');
        }
    };

    const handleSaveArea = async () => {
        if (!validateField(area, 'Area')) return;
        try {
            const formData = new FormData();
            formData.append("area_name", area);
            formData.append("user_id", ACCESS_Log_In_User_Id());
            formData.append("role_id", ACCESS_Role_ID());
            formData.append("status", "1");

            const response = await axios.post(`${API_BASE_URL}/createFindTheCenterArea/null`, formData);
            alert(response.data.message || 'Area saved!');
            setArea('');
            fetchAreas()
        } catch (error) {
            console.error("Error saving area:", error);
            alert('Error saving area');
        }
    };



    const toggleEditMode1 = (index) => {
        setCategories(prev =>
            prev.map((cat, i) =>
                i === index ? { ...cat, isEditing: !cat.isEditing } : cat
            )
        );
    };

    const handleEditInputChange = (index, value) => {
        setCategories(prev =>
            prev.map((cat, i) =>
                i === index ? { ...cat, category_name: value } : cat
            )
        );
    };

    const saveExistingCategory = async (index) => {
        const cat = categories[index];
        console.log("deepak data", cat.category_name)
        // return false
        try {
            const formData = new FormData();
            formData.append('category_name', cat.category_name);
            formData.append('user_id', ACCESS_Log_In_User_Id());
            formData.append('role_id', ACCESS_Role_ID());
            formData.append('status', '1');

            await axios.post(`${API_BASE_URL}/createFindTheCenterCategory/${cat.id}`, formData);
            alert('Updated successfully!');
            fetchCategories();
        } catch (error) {
            console.error('Error updating category:', error);
        }
    };


    const deleteExistingCategory = async (index) => {
        const cat = categories[index];
        console.log("deepak data", cat.category_name)
        // return false
        try {

            await axios.delete(`${API_BASE_URL}/deleteFindTheCenterCategoryById/${cat.id}`);
            alert('delete successfully!');
            fetchCategories();
        } catch (error) {
            console.error('Error updating category:', error);
        }
    };



    const saveFinderData = async (e) => {
        e.preventDefault();
      
        const user_id = ACCESS_Log_In_User_Id();
        const role_id = ACCESS_Role_ID();
      
        const queryParams = new URLSearchParams({
          role_id,
          user_id,
          category_name: selectedCategory,
          board_name: selectedBoard,
          standards_name: selectedStandard,
          city_name: selectedCity,
          area_name: selectedArea,
          status: 0,
          place_name: placeName,
          phone_no: mobile,
          email,
          address
        }).toString();
      
        const url = `${API_BASE_URL}/createFindTheCenter/null?${queryParams}`;
      
        try {
          const res = await axios.post(url);
          console.log("API response:", res.data);
          alert(res.data.message || "Center saved successfully");
        } catch (error) {
          console.error('Error saving finder data:', error);
          alert('Error saving data');
        }
      };
      




    // const saveTopper = async () => {
    //     try {
    //       const response = await axios.post(`${API_BASE_URL}/toppers/${id}`, {
    //         toppers: branches,
    //         user_id: ACCESS_Log_In_User_Id(),
    //         role_id: ACCESS_Role_ID(),
    //       });
    //       alert(response.data.message);
    //     } catch (error) {
    //       console.error("Error saving toppers:", error);
    //     }
    // };

    //const profileUrl = "http://localhost:3000/instituteProfile/1/link"; // Replace with dynamic URL if needed

    // return (
    //   <div style={{ textAlign: "center", marginTop: "20px" }}>
    //     <h1>Scan the QR Code</h1>
    //     <QRCode value={profileUrl} size={200} />
    //   </div>
    // );
    //   };

    return (
        <div className="bg_dashboard">
            {/* Mobile Menu */}


            {/* <CommanStudentTeacherHeader/> */}

            {/* Main Container */}
            <div className="container">
                <div className="row">
                    {/* Sidebar */}
                    {/* <StudentSidebar /> */}
                    <CommanInstitute />
                    <CommonInstituteMob />

                    {/* Main Content */}
                    <div className="col-sm-9 col-md-12 col-xl-9 px-md-5 ps-xl-5 ">
                        {/* <div className="row mt-5">
                            <div className="col-md-9 ps-0">
                                <div className="search-box dashboard_search">
                                    <input type="text"
                                        className="common-input common-input--lg dashboard_search_input pill shadow-sm auto-suggestion-input"
                                        placeholder="Search" />
                                    <button type="submit" className="btn btn-main spl_burron  border-0"><img
                                        src={SearchIcon} alt="" /></button>
                                </div>
                            </div>
                            <div className="col-md-2 text-xl-center  mt-3">
                                <img src={NotificationIcon} alt="" />
                            </div>
                            <div className="col-md-1">
                                <div className="dashboard_profile ms-auto">
                                    <img src={profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : ProfileImage} alt="" />
                                </div>
                            </div>
                        </div> */}
                        <p className="learm-tilte my-3">Edit Profile</p>

                        <div className="row p-0 mb-5">
                            <div className="dashboard_card p-0">
                                <div className="row align-items-center p-4">
                                    <div className="col-sm-4 col-lg-4 col-xl-2">
                                        <div className="dasboard_profile mx-auto">
                                            <img src={profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : ProfileImage} alt="Profile Image" className="rounded-circle" />
                                        </div>

                                    </div>
                                    <div className="col-sm-4 col-lg-8 col-xl-8 text-center text-lg-start ps-lg-5">
                                        {flags === "website" && (
                                            <button className="btn btn-outline-light btn-outline-dark my-2 my-lg-0" onClick={() => document.getElementById("fileInput").click()}>Upload your college/university logo</button>
                                        )}
                                        <input type="file" id="fileInput" accept="image/*" style={{ display: "none" }}
                                            onChange={updateProfileImage} />

                                        <p className="mt-2 profiel_text text-start">At least 800x800 px recommended.
                                            JPG or PNG is allowed</p>
                                    </div>
                                    {/* <div style={{ textAlign: "center" }}>
      <canvas ref={canvasRef} width={200} height={230} style={{ border: "1px solid #000" }} />
      <br />
      <button onClick={generateQR} style={{ margin: "10px" }}>
        Generate QR Code
      </button>
      <button onClick={handleDownload} style={{ margin: "10px" }}>
        Download QR Code
      </button>
    </div> */}
                                    <div className="col-sm-4 col-lg-8 col-xl-2 mt-4 mt-sm-0">
                                        <canvas ref={canvasRef} width={200} height={230} style={{ border: "1px solid #000", display: "none" }} />
                                        <div
                                            className="dasboard_profile_qr mx-auto d-flex justify-content-center align-items-center" onClick={() => setShowOptions(!showOptions)} style={{ cursor: "pointer" }}>
                                            <QRCode value={dashboardUrl} size={100} />
                                            {/* <img src={profileUrl} alt="Profile Image" className="" /> */}
                                        </div>

                                        {showOptions && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "10%",
                                                    background: "#fff",
                                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                    padding: "10px",
                                                    borderRadius: "8px",
                                                    zIndex: 10,

                                                }}
                                            >
                                                <button
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        padding: "10px",
                                                        margin: "5px 0",
                                                        cursor: "pointer",
                                                        border: "none",
                                                        backgroundColor: "transparent",
                                                    }}
                                                    onClick={shareToFacebook}
                                                >
                                                    <img
                                                        src="https://img.icons8.com/fluency/48/000000/facebook-new.png"
                                                        alt="Facebook"
                                                        style={{ width: "24px", marginRight: "10px" }}
                                                    />
                                                    Share to Facebook
                                                </button>
                                                <button
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        padding: "10px",
                                                        margin: "5px 0",
                                                        cursor: "pointer",
                                                        border: "none",
                                                        backgroundColor: "transparent",
                                                    }}
                                                    onClick={shareToWhatsApp}
                                                >
                                                    <img
                                                        src="https://img.icons8.com/color/48/000000/whatsapp.png"
                                                        alt="WhatsApp"
                                                        style={{ width: "24px", marginRight: "10px" }}
                                                    />
                                                    Share to WhatsApp
                                                </button>
                                                <button
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        padding: "10px",
                                                        margin: "5px 0",
                                                        cursor: "pointer",
                                                        border: "none",
                                                        backgroundColor: "transparent",
                                                    }}
                                                    onClick={shareToTwitter}
                                                >
                                                    <img
                                                        src="https://img.icons8.com/fluency/48/000000/twitter.png"
                                                        alt="Twitter"
                                                        style={{ width: "24px", marginRight: "10px" }}
                                                    />
                                                    Share to Twitter
                                                </button>
                                                <button
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        padding: "10px",
                                                        margin: "5px 0",
                                                        cursor: "pointer",
                                                        border: "none",
                                                        backgroundColor: "transparent",
                                                    }}
                                                    onClick={handleDownload}
                                                >
                                                    <img
                                                        src={DownloadIcon}
                                                        alt="Twitter"
                                                        style={{ width: "24px", marginRight: "10px" }}
                                                    />
                                                    Download
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <hr className="dashboard_line" />
                                <div className="row py-4 px-5">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-7 col-sm-8">
                                                <p className="profile_text_2">Personal Info</p>
                                            </div>
                                            <div className="col-sm-4 col-5 text-end">
                                                {flags === "website" && (
                                                    <button onClick={personalInfoEdit}>
                                                        <img src={EditIcon} alt="Edit" /> {profileDataEditable ? "Save" : "Edit"}
                                                    </button>
                                                )}

                                            </div>
                                            <div className="col-sm-12 d-flex justify-content-between flex-column flex-lg-row mt-4">
                                                <div className="">
                                                    <p className="">Full Name</p>
                                                    {profileDataEditable ? (
                                                        <input
                                                            type="text"
                                                            name="full_name"
                                                            value={profileData['full_name']}
                                                            onChange={handleChange}
                                                            className="common-input dashboard_editable_input"
                                                        />
                                                    ) : (
                                                        <p className="profile_text_1 mt-2">{profileData['full_name']}</p>
                                                    )}
                                                </div>
                                                <div className="">
                                                    <p className="">Email</p>
                                                    {profileDataEditable ? (
                                                        <input
                                                            type="email"
                                                            name="email_id"
                                                            value={profileData.email_id}
                                                            onChange={handleChange}
                                                            className="common-input dashboard_editable_input"
                                                            readOnly

                                                        />
                                                    ) : (
                                                        <p className="profile_text_1 mt-2">{profileData.email_id}</p>
                                                    )}
                                                </div>
                                                <div className="">
                                                    <p className="">Username</p>
                                                    {profileDataEditable ? (
                                                        <input
                                                            type="text"
                                                            name="username"
                                                            value={profileData.username}
                                                            onChange={handleChange}
                                                            className="common-input dashboard_editable_input"
                                                        />
                                                    ) : (
                                                        <p className="profile_text_1 mt-2">{profileData.username}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-4">
                                                <p className="profile_text_2 mb-3">Location</p>

                                                <div className="position-relative">
                                                    {profileDataEditable ? (
                                                        <input
                                                            type="text"
                                                            name="location"
                                                            value={profileData.location}
                                                            onChange={handleChange}
                                                            className="common-input dashboard_editable_input"
                                                        />
                                                    ) : (

                                                        <span class="input-icon input-icon--left text-main">{profileData.location}


                                                        </span>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-7 col-sm-8">
                                                <p className="profile_text_2">Bio</p>
                                            </div>
                                            <div className="col-sm-4 col-5 text-end">
                                                {flags === "website" && (
                                                    <button onClick={BioInfoEdit}>
                                                        <img src={EditIcon} alt="Edit" />
                                                        {bioInfoEditable ? "Save" : "Edit"}
                                                    </button>
                                                )}

                                            </div>
                                            <div className="col-sm-12 mt-4">
                                                {bioInfoEditable ? (
                                                    <textarea
                                                        name="bio_info"
                                                        value={bioInfo.bio_info}
                                                        onChange={handleChange1}
                                                        className="common-input dashboard_editable_input"
                                                        rows="4"
                                                    ></textarea>
                                                ) : (
                                                    <p>{bioInfo.bio_info}</p>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">

                                        <div className="row px-0 px-sm-3">

                                            <div className="col-sm-12 mt-4">
                                                <label htmlFor="numStudents" className="profile_text_2 mb-3">No. of Students Studying (Approx.)</label>
                                                <input
                                                    type="number"
                                                    name="no_of_students_studyind"
                                                    value={otherInfoDetails.no_of_students_studyind}
                                                    onChange={handleOtherInfoDetails}
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    placeholder="Enter number of students"
                                                />
                                            </div>


                                            <div className="col-sm-12 mt-4">
                                                <label htmlFor="yearEstablishment" className="profile_text_2 mb-3">Year of Establishment</label>
                                                <input
                                                    type="number"
                                                    name="year_of_establishment"
                                                    value={otherInfoDetails.year_of_establishment}
                                                    onChange={handleOtherInfoDetails}
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    placeholder="Enter year"
                                                />
                                            </div>


                                            <div className="col-sm-12 mt-4">
                                                <label htmlFor="timings" className="profile_text_2 mb-3">Timings</label>
                                                <input
                                                    type="text"
                                                    name="timings"
                                                    value={otherInfoDetails.timings}
                                                    onChange={handleOtherInfoDetails}
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    placeholder="Enter timings"
                                                />
                                            </div>

                                            <div className="col-sm-12 mt-4">
                                                <label htmlFor="hostels" className="profile_text_2 mb-3">Hostels</label>
                                                <select
                                                    name="hostels"
                                                    value={otherInfoDetails.hostels}
                                                    onChange={handleOtherInfoDetails}
                                                    className="common-input common-input--md dash_borad_input_1"
                                                >
                                                    <option disabled>Available</option>
                                                    <option value="available">Yes</option>
                                                    <option value="not available">No</option>
                                                </select>
                                            </div>




                                            <div className="col-sm-12 mt-4">
                                                <label htmlFor="approvedBy" className="profile_text_2 mb-3">Approved by</label>
                                                <input
                                                    type="text"
                                                    name="approved_by"
                                                    id="approvedBy"
                                                    value={otherInfoDetails.approved_by} // Updated to align with the state object `otherInfoDetails`
                                                    onChange={handleOtherInfoDetails}
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    placeholder="Enter details"
                                                />
                                            </div>





                                            <div className="col-sm-12 mt-4">
                                                <label htmlFor="affiliation" className="profile_text_2 mb-3">Affiliation</label>
                                                <select
                                                    name="affiliation"
                                                    id="affiliation"
                                                    value={otherInfoDetails.affiliation} // Bind to state
                                                    onChange={handleOtherInfoDetails} // Update state dynamically
                                                    className="common-input common-input--md dash_borad_input_1"
                                                >
                                                    <option value="" disabled>Select Affiliation</option> {/* Default placeholder */}
                                                    <option value="private">Private</option>
                                                    <option value="government">Government</option>
                                                    <option value="semi-government">Semi-Government</option>
                                                </select>
                                            </div>





                                            <div className="col-sm-12 mt-4">
                                                <label htmlFor="genderComposition" className="profile_text_2 mb-3">Gender Composition</label>
                                                <div className="d-flex flex-column">
                                                    <div className="form-check">
                                                        <input
                                                            type="radio"
                                                            id="coed"
                                                            name="gender_composition"
                                                            value="coed"
                                                            className="form-check-input"
                                                            checked={otherInfoDetails.gender_composition === 'coed'}
                                                            onChange={handleOtherInfoDetails}
                                                        />
                                                        <label htmlFor="coed" className="form-check-label">Co-ed</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="radio"
                                                            id="boys"
                                                            name="gender_composition"
                                                            value="boys"
                                                            className="form-check-input"
                                                            checked={otherInfoDetails.gender_composition === 'boys'}
                                                            onChange={handleOtherInfoDetails}
                                                        />
                                                        <label htmlFor="boys" className="form-check-label">Boys</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="radio"
                                                            id="girls"
                                                            name="gender_composition"
                                                            value="girls"
                                                            className="form-check-input"
                                                            checked={otherInfoDetails.gender_composition === 'girls'}
                                                            onChange={handleOtherInfoDetails}
                                                        />
                                                        <label htmlFor="girls" className="form-check-label">Girls</label>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-sm-12 mt-4 text-end">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={CreateUpdateOtherInfoDetails}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        color: 'blue',
                                                        cursor: 'pointer',
                                                        textDecoration: 'underline',
                                                    }}
                                                >
                                                    Save
                                                </button>
                                            </div>




                                            <div className="col-sm-12 mt-4">
                                                <div className="d-flex justify-content-between mb-3">
                                                    <label htmlFor="stream" className="profile_text_2">Stream</label>
                                                    <button type="button" className="" onClick={handleToggleSection}>
                                                        <img src={teacherSvg} alt="Add Teacher" />
                                                    </button>
                                                </div>

                                                {/* <div className="d-flex justify-content-between align-items-center">
                                                <p className="common-input common-input--md dash_borad_input_1">{streamDetails?.stream_name}</p>
                                                </div> */}
                                            </div>


                                            {/* <div className="col-sm-12 mt-4">
                                                {streamDetails1.map((stream, index) => (
                                                    <div key={index} className="border p-3 bg-light mb-4">
                                                       
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <label htmlFor={`stream-${index}`} className="profile_text_2">
                                                                Stream
                                                            </label>
                                                            <button type="button" className="" >
                    <p>edit</p>
                </button>
                                                        </div>

                                                        
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p className="common-input common-input--md dash_borad_input_1">
                                                                {stream.stream_name}
                                                            </p>
                                                        </div>

                                                      
                                                        <h5 className="mt-4">{stream.degree || "Bachelors in Business Management"}</h5>
                                                        <div className="row mt-3 align-items-end">
                                                            <div className="col-sm-4">
                                                                <label htmlFor={`fee-${index}`} className="profile_text_2 mb-3">
                                                                    Fee Structure
                                                                </label>
                                                                <p className="common-input common-input--md dash_borad_input_1">
                                                                    {stream.fee || "N/A"}
                                                                </p>
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <label htmlFor={`year-${index}`} className="profile_text_2 mb-3">
                                                                    Year
                                                                </label>
                                                                <p className="common-input common-input--md dash_borad_input_1">
                                                                    {stream.year || "N/A"}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        
                                                        <div className="mt-3">
                                                            <label htmlFor={`bio-${index}`} className="profile_text_2 mb-3">
                                                                Bio
                                                            </label>
                                                            <p className="common-input common-input--md dash_borad_input_1">
                                                                {stream.stream_bio || "No bio available"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div> */}

                                            <div className="col-sm-12 mt-4">
                                                {streams.map((stream, index) => (
                                                    <div key={index} className="border p-3 bg-light mb-4">
                                                        {/* Stream Header */}
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <label htmlFor={`stream-${index}`} className="profile_text_2">
                                                                Stream
                                                            </label>
                                                            {editingIndex === index ? (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => CreateUpdateOtherInfoDetails1(index)}
                                                                    className="btn btn-primary"
                                                                >
                                                                    Save
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleEditClick4(index)}
                                                                    className="btn btn-secondary"
                                                                >
                                                                    Edit
                                                                </button>
                                                            )}
                                                        </div>

                                                        {/* Stream Name */}
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            {editingIndex === index ? (
                                                                <input
                                                                    type="text"
                                                                    value={stream.stream_name || ''}
                                                                    onChange={(e) =>
                                                                        handleChange4(index, 'stream_name', e.target.value)
                                                                    }
                                                                    className="form-control"
                                                                />
                                                            ) : (
                                                                <p className="common-input common-input--md dash_borad_input_1">
                                                                    {stream.stream_name}
                                                                </p>
                                                            )}
                                                        </div>

                                                        {/* Stream Details */}
                                                        {/* <h5 className="mt-4">
                        {editingIndex === index ? (
                            <input
                                type="text"
                                value={stream.degree || ''}
                                onChange={(e) =>
                                    handleChange4(index, 'degree', e.target.value)
                                }
                                className="form-control"
                            />
                        ) : (
                            stream.degree || "Bachelors in Business Management"
                        )}
                    </h5> */}
                                                        <div className="row mt-3 align-items-end">
                                                            <div className="col-sm-4">
                                                                <label htmlFor={`fee-${index}`} className="profile_text_2 mb-3">
                                                                    Fee Structure
                                                                </label>
                                                                {editingIndex === index ? (
                                                                    <input
                                                                        type="text"
                                                                        value={stream.fee || ''}
                                                                        onChange={(e) =>
                                                                            handleChange4(index, 'fee', e.target.value)
                                                                        }
                                                                        className="form-control"
                                                                    />
                                                                ) : (
                                                                    <p className="common-input common-input--md dash_borad_input_1">
                                                                        {stream.fee || "N/A"}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <label htmlFor={`year-${index}`} className="profile_text_2 mb-3">
                                                                    Year
                                                                </label>
                                                                {editingIndex === index ? (
                                                                    <input
                                                                        type="text"
                                                                        value={stream.year || ''}
                                                                        onChange={(e) =>
                                                                            handleChange4(index, 'year', e.target.value)
                                                                        }
                                                                        className="form-control"
                                                                    />
                                                                ) : (
                                                                    <p className="common-input common-input--md dash_borad_input_1">
                                                                        {stream.year || "N/A"}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Stream Bio */}
                                                        <div className="mt-3">
                                                            <label htmlFor={`bio-${index}`} className="profile_text_2 mb-3">
                                                                Bio
                                                            </label>
                                                            {editingIndex === index ? (
                                                                <textarea
                                                                    value={stream.stream_bio || ''}
                                                                    onChange={(e) =>
                                                                        handleChange4(index, 'stream_bio', e.target.value)
                                                                    }
                                                                    className="form-control"
                                                                />
                                                            ) : (
                                                                <p className="common-input common-input--md dash_borad_input_1">
                                                                    {stream.stream_bio || "No bio available"}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>


                                            {isSectionOpen && (
                                                <div className="col-sm-12 mt-2">
                                                    <label htmlFor="stream" className="profile_text_2 mb-3">Stream</label>
                                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                                        <input
                                                            type="text"
                                                            name="stream_name"
                                                            id="stream"
                                                            value={streamDetails.stream_name}
                                                            onChange={handleStreamDetails}
                                                            className="common-input common-input--md dash_borad_input_1"
                                                            placeholder="Business"
                                                        />
                                                    </div>
                                                    <div className="col-sm-12 mt-4">
                                                        <div className="border p-3 bg-light">
                                                            <h5>Bachelors in Business Management</h5>

                                                            <div className="row mt-3 align-items-end">
                                                                <div className="col-sm-4">
                                                                    <label htmlFor="feeAmount" className="profile_text_2 mb-3">Fee Structure</label>
                                                                    <input
                                                                        type="number"
                                                                        name="fee"
                                                                        id="feeAmount"
                                                                        value={streamDetails.fee || ''}
                                                                        onChange={handleStreamDetails}
                                                                        className="common-input common-input--md dash_borad_input_1"
                                                                        placeholder="Enter Amount"
                                                                    />
                                                                </div>
                                                                <div className="col-sm-4">
                                                                    <select
                                                                        name="year"
                                                                        id="feeYear"
                                                                        value={streamDetails.year || ''}
                                                                        onChange={handleStreamDetails}
                                                                        className="common-input common-input--md dash_borad_input_1"
                                                                    >
                                                                        <option value="" disabled>Select Year</option>
                                                                        <option value="2015">2015</option>
                                                                        <option value="2016">2016</option>
                                                                        <option value="2017">2017</option>
                                                                        <option value="2018">2018</option>
                                                                        <option value="2019">2019</option>
                                                                        <option value="2020">2020</option>
                                                                        <option value="2021">2021</option>
                                                                        <option value="2022">2022</option>
                                                                        <option value="2023">2023</option>
                                                                        <option value="2024">2024</option>
                                                                        <option value="2025">2025</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="mt-3">
                                                                <label htmlFor="bio" className="profile_text_2 mb-3">Bio</label>
                                                                <textarea
                                                                    id="bio"
                                                                    name="stream_bio"
                                                                    rows="4"
                                                                    value={streamDetails.stream_bio || ''}
                                                                    onChange={handleStreamDetails}
                                                                    className="common-input common-input--md dash_borad_input_1"
                                                                    placeholder="Enter details about the program"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            <div className="col-sm-12 mt-4 text-end">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={CreateUpdateStreamDetails}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        color: 'blue',
                                                        cursor: 'pointer',
                                                        textDecoration: 'underline',
                                                    }}
                                                >
                                                    Save
                                                </button>
                                            </div>



                                            {/* <div className="col-sm-12 mt-4">
                                                <div className="border p-3 bg-light">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <input
                                                            type="text"
                                                            className="form-control border-0 bg-light h5 mb-0"
                                                            value="Masters in Business Management"
                                                            readOnly
                                                        />
                                                        <button type="button" className="btn p-0">
                                                            <img src={editSvg} alt="Edit" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>*/}






                                        </div>

                                        {/* <div className="col-sm-12 mt-4">


                                                <div className="d-flex justify-content-between align-items-center mb-4">
                                                    <input
                                                        type="text"


                                                        className="common-input common-input--md dash_borad_input_1"
                                                        placeholder="Technology"
                                                    />
                                                </div>
                                                <div className="col-sm-12 mt-1 text-end">
                                                    <span className="learm-tilte2">Add specialization</span>
                                                </div>

                                            </div>

                                            <div className="col-sm-12 mt-4">


                                                <div className="d-flex justify-content-between align-items-center mb-4">
                                                    <input
                                                        type="text"


                                                        className="common-input common-input--md dash_borad_input_1"
                                                        placeholder="Technology"
                                                    />
                                                </div>
                                                <div className="col-sm-12 mt-1 text-end">
                                                    <span className="learm-tilte2">Add specialization</span>
                                                </div>

                                            </div> */}

                                        {/* <div className="col-sm-12 mt-4">
                                         
                                            <div className="d-flex justify-content-between mb-3">
                                                <label htmlFor="Facilities" className="profile_text_2">Facilities</label>
                                                <button
                                                    type="button"
                                                    className=""
                                                    onClick={handleToggleSection1}
                                                >
                                                    <img src={teacherSvg} alt="Add Teacher" />
                                                </button>
                                            </div>

                                            
                                           {facilitydata?.map((stream, index) => <div className="d-flex justify-content-between align-items-center mb-4">
                                                <p className="common-input common-input--md dash_borad_input_1">
                                                    {stream?.facilities_name}
                                                </p>
                                            </div>)}

                                           
                                            {isSectionOpen1 && (
                                                <div className="d-flex justify-content-between align-items-center mb-4">
                                                    <input
                                                        type="text"
                                                        name="facility_name"
                                                        id="facility"
                                                        onChange={(e) => setFacility(e.target.value)} // Corrected the onChange handler
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        placeholder="Business"
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-sm-12 mt-4 text-end">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={CreateUpdateInstitutesFacilities}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        color: 'blue',
                                                        cursor: 'pointer',
                                                        textDecoration: 'underline',
                                                    }}
                                                >
                                                    Save
                                                </button>
                                        </div> */}

                                        <div className="col-sm-12 mt-4">
                                            {/* Facilities Header */}
                                            <div className="d-flex justify-content-between mb-3">
                                                <label htmlFor="Facilities" className="profile_text_2">Facilities</label>
                                                <button
                                                    type="button"
                                                    className=""
                                                    onClick={handleToggleSection1}
                                                >
                                                    <img src={teacherSvg} alt="Add Teacher" />
                                                </button>
                                            </div>

                                            {/* Facilities List */}
                                            {facilitydata?.map((facility, index) => (
                                                <div key={index} className="d-flex justify-content-between align-items-center mb-4">
                                                    {editingIndex2 === index ? (
                                                        <input
                                                            type="text"
                                                            value={facility.facilities_name || ''}
                                                            onChange={(e) =>
                                                                handleChange5(index, 'facilities_name', e.target.value)
                                                            }
                                                            className="common-input common-input--md dash_borad_input_1"
                                                        />
                                                    ) : (
                                                        <p className="common-input common-input--md dash_borad_input_1">
                                                            {facility.facilities_name}
                                                        </p>
                                                    )}
                                                    {editingIndex2 === index ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={() => updateInstitutesFacilities(index)}
                                                        >
                                                            Save
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"

                                                            className="btn btn-secondary"
                                                            onClick={() => handleEditClick5(index)}
                                                        >
                                                            Edit
                                                        </button>
                                                    )}
                                                </div>
                                            ))}

                                            {/* Add New Facility Section */}
                                            {isSectionOpen1 && (
                                                <div className="d-flex justify-content-between align-items-center mb-4">
                                                    <input
                                                        type="text"
                                                        name="facility_name"
                                                        id="facility"
                                                        value={facilty}
                                                        onChange={(e) => setFacility(e.target.value)}
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        placeholder="Enter Facility Name"
                                                    />
                                                </div>
                                            )}

                                            {/* Save Button */}
                                            <div className="col-sm-12 mt-4 text-end">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={CreateUpdateInstitutesFacilities}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        color: 'blue',
                                                        cursor: 'pointer',
                                                        textDecoration: 'underline',
                                                    }}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>




                                    </div>
                                </div>


                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label htmlFor="mediaUpload" className="profile_text_2 mb-3 learn-title2">
                                                    Upload Media
                                                </label>

                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        id="courseTitle"
                                                        placeholder={selectedFile ? selectedFile.name : "No file selected"}
                                                        maxLength="60"
                                                        readOnly
                                                    />
                                                    <span
                                                        className="character-count position-absolute"
                                                        style={{
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                        }}
                                                    >
                                                        <label htmlFor="mediaFile" className="media-btn" style={{ cursor: 'pointer' }}>
                                                            <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                            <span>Media</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="mediaFile"
                                                            style={{ display: 'none' }}
                                                            onChange={handleFileChange}
                                                        />
                                                    </span>
                                                </div>

                                                <label className="note learm-tilte2 fw-500 font-14">
                                                    Note: All files should be at least 720p and less than 4.0 GB.
                                                </label>

                                                <div className="mt-3 text-end">
                                                    <button
                                                        onClick={handleUploadClick}
                                                        className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20"
                                                    >
                                                        Upload File
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Upload Brouchure */}
                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label htmlFor="mediaUpload" className="profile_text_2 mb-3 learn-title2">
                                                    Upload Brouchure
                                                </label>

                                                {/* <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        id="courseTitle"
                                                        placeholder={selectedBrouchureFile ? selectedBrouchureFile.name : "No file selected"}
                                                        maxLength="60"
                                                        readOnly
                                                    />
                                                    <span
                                                        className="character-count position-absolute"
                                                        style={{
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                        }}
                                                    >
                                                        <label htmlFor="mediaFile" className="media-btn" style={{ cursor: 'pointer' }}>
                                                            <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                            <span>Media</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="mediaFile"
                                                            style={{ display: 'none' }}
                                                            onChange={handleFileChange}
                                                        />
                                                    </span>
                                                </div> */}

                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        id="courseTitle1"
                                                        placeholder={selectedBrouchureFile ? selectedBrouchureFile.name : "No file selected"}
                                                        maxLength="60"
                                                        readOnly
                                                    />
                                                    <span
                                                        className="character-count position-absolute"
                                                        style={{
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                        }}
                                                    >
                                                        <label htmlFor="mediaFile1" className="media-btn" style={{ cursor: 'pointer' }}>
                                                            <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                            <span>Upload Brouchure</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="mediaFile1"
                                                            accept="application/pdf"
                                                            style={{ display: 'none' }}
                                                            onChange={handleFileChange12}
                                                        />
                                                    </span>
                                                </div>

                                                <label className="note learm-tilte2 fw-500 font-14">
                                                    Note: All files should be at least 720p and less than 4.0 GB.
                                                </label>

                                                <div className="mt-3 text-end">
                                                    <button
                                                        onClick={handleUploadBrouchureClick}
                                                        className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20"
                                                    >
                                                        Upload File
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-7 col-sm-8">
                                                <p className="profile_text_2">Personal Info</p>
                                            </div>
                                            <div className="col-sm-4 col-5 text-end">
                                                <span
                                                    className="learm-tilte2"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={isEditable2 ? CreateUpdateinstituteManagerPersonalInfo : handleEditClick2}
                                                >
                                                    {isEditable2 ? "Save" : "Add Manager"}
                                                </span>
                                            </div>
                                            <div className="col-sm-12 d-flex justify-content-between flex-column flex-lg-row mt-4">
                                                <div>
                                                    <p>Full Name</p>
                                                    {isEditable2 ? (
                                                        <input
                                                            type="text"
                                                            name="fullName"
                                                            value={managerDetails2.fullName}
                                                            onChange={handleInputChange2}
                                                            className="common-input"
                                                        />
                                                    ) : (
                                                        <p className="profile_text_1 mt-2">
                                                            {managerDetails2.fullName}
                                                        </p>
                                                    )}
                                                </div>
                                                <div>
                                                    <p>Email</p>
                                                    {isEditable2 ? (
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            value={managerDetails2.email}
                                                            onChange={handleInputChange2}
                                                            className="common-input"
                                                        />
                                                    ) : (
                                                        <p className="profile_text_1 mt-2">
                                                            {managerDetails2.email}
                                                        </p>
                                                    )}
                                                </div>
                                                <div>
                                                    <p>phone</p>
                                                    {isEditable2 ? (
                                                        <input
                                                            type="text"
                                                            name="phone"
                                                            value={managerDetails2.phone}
                                                            onChange={handleInputChange2}
                                                            className="common-input"
                                                        />
                                                    ) : (
                                                        <p className="profile_text_1 mt-2">
                                                            {managerDetails2.phone}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-4">
                                                <p className="profile_text_2 mb-3">Location</p>
                                                <div className="position-relative">
                                                    <input
                                                        type="url"
                                                        name="location"
                                                        value={managerDetails2.location || ""}
                                                        onChange={handleInputChange2}
                                                        className={`common-input common-input--md dash_borad_input common-input--withLeftIcon ${isEditable2 ? "" : "disabled"}`}
                                                        id="facebookUrl"
                                                        placeholder="Facebook Profile Url"
                                                        disabled={!isEditable2}
                                                    />
                                                    <span className="input-icon input-icon--left text-main">
                                                        <img src={LocationIcon} alt="" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                {/* {!isEditable2 && (<div className="row px-5 pb-4">
                                    {managers?.map((stream, index) => <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-7 col-sm-8">
                                                <p className="profile_text_2">Personal Info</p>
                                            </div>


                                            <div className="col-sm-12 d-flex justify-content-between flex-column flex-lg-row mt-4">
                                                <div>
                                                    <p>Full Name</p>
                                                    <p className="profile_text_1 mt-2">
                                                        {stream.full_name}
                                                    </p>

                                                </div>
                                                <div>
                                                    <p>Email</p>

                                                    <p className="profile_text_1 mt-2">
                                                        {stream.email_id}
                                                    </p>

                                                </div>
                                                <div>
                                                    <p>phone</p>

                                                    <p className="profile_text_1 mt-2">
                                                        {stream.phone_no}
                                                    </p>

                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-4">
                                                <p className="profile_text_2 mb-3">Location</p>
                                                <div className="position-relative">
                                                    <p className={`common-input common-input--md dash_borad_input common-input--withLeftIcon`}>{stream.location}</p>
                                                    <span className="input-icon input-icon--left text-main">
                                                        <img src={LocationIcon} alt="" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}
                                </div>)} */}

                                <div class="row px-5 pb-4">
                                    <div class="dashboard_sub_card">
                                        <div class="row px-0 px-sm-3">
                                            <div class="col-sm-12">
                                                <label for="mediaUpload" class="profile_text_2 mb-3 learn-title2">Our branches</label>
                                                <div class="position-relative">
                                                    {branches.map((branch, index) => (
                                                        <div key={index}>
                                                            <div class="col-sm-12">
                                                                <label for="fee-0" class="profile_text_2 mb-3">Branch name</label>
                                                                <input
                                                                    className='common-input common-input--md dash_borad_input_1'
                                                                    type="text"
                                                                    name="name"
                                                                    placeholder="Branch Name"
                                                                    value={branch.name}
                                                                    onChange={(e) => handleChange6(index, e)}
                                                                />
                                                            </div>
                                                            <div class="col-sm-12">
                                                                <label for="fee-0" class="profile_text_2 mb-3">Contact number</label>
                                                                <input
                                                                    className='common-input common-input--md dash_borad_input_1'
                                                                    type="text"
                                                                    name="contact_number"
                                                                    placeholder="Branch contact number"
                                                                    value={branch.phone_no}
                                                                    onChange={(e) => handleChange6(index, e)}
                                                                />
                                                            </div>
                                                            <div class="col-sm-12">
                                                                <label for="fee-0" class="profile_text_2 mb-3">Email address</label>
                                                                <input
                                                                    className='common-input common-input--md dash_borad_input_1'
                                                                    type="text"
                                                                    name="email_id"
                                                                    placeholder="Email address"
                                                                    value={branch.email_id}
                                                                    onChange={(e) => handleChange6(index, e)}
                                                                />
                                                            </div>
                                                            <div class="col-sm-12" style={{ marginBottom: "20px" }}>
                                                                <label for="fee-0" class="profile_text_2 mb-3">Branch address</label>
                                                                <input
                                                                    type="text"
                                                                    className='common-input common-input--md dash_borad_input_1'
                                                                    name="address"
                                                                    placeholder="Branch Address"
                                                                    value={branch.address}
                                                                    onChange={(e) => handleChange6(index, e)}
                                                                />
                                                            </div>
                                                            <button onClick={addBranch} class="background-color: transparent; border: medium; color: blue; cursor: pointer; text-decoration: underline;">Add More</button>
                                                            <button onClick={saveBranches} class="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20" style={{ float: "right" }}>Save</button>
                                                        </div>

                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3 learn-title2">Our Toppers</label>
                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Topper Name</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="topper_name"
                                                        placeholder="Topper name"
                                                        value={topperData.topper_name}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Exam</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="exam"
                                                        placeholder="Exam name"
                                                        value={topperData.exam}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Rank</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="rank"
                                                        placeholder="AIR"
                                                        value={topperData.rank}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-sm-12" style={{ marginBottom: "20px" }}>
                                                    <label className="profile_text_2 mb-3">Image</label>
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="common-input common-input--md dash_borad_input_1"
                                                            placeholder={selectedTopperFile ? selectedTopperFile.name : "No file selected"}
                                                            readOnly
                                                        />
                                                        <label htmlFor="mediaFile" className="media-btn" style={{ cursor: "pointer" }}>
                                                            <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                            <span>Media</span>
                                                        </label>
                                                        <input type="file" id="mediaFile" style={{ display: "none" }} onChange={handleFileChange} accept="image/*" />
                                                    </div>
                                                </div>
                                                <button onClick={saveTopper} className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20" style={{ float: "right" }}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3 learn-title2">Our Expert</label>

                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Expert Name</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="expert_name"
                                                        placeholder="Expert name"
                                                        value={expertData.expert_name}
                                                        onChange={handleInputChange1}
                                                    />
                                                </div>

                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Rank</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="rank"
                                                        placeholder="AIR"
                                                        value={expertData.rank}
                                                        onChange={handleInputChange1}
                                                    />
                                                </div>

                                              
                                                <div className="col-sm-12 mb-3">
                                                    <label className="profile_text_2 mb-3">Image</label>
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="common-input common-input--md dash_borad_input_1"
                                                            placeholder={selectedExpertFile ? selectedExpertFile.name : "No file selected"}
                                                            readOnly
                                                        />
                                                        <label htmlFor="expertFile" className="media-btn" style={{ cursor: "pointer" }}>
                                                            <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                            <span>Media</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="expertFile"
                                                            style={{ display: "none" }}
                                                            onChange={handleExpertFileChange}
                                                            accept="image/*"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-end">
                                                    <button onClick={saveExpert} className="btn btn_cousre bg-main-btn text-white">
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3 learn-title2">Add New Expert</label>

                                                {/* New Expert Form */}
                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Expert Name</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="expert_name"
                                                        placeholder="Expert name"
                                                        value={newExpert.expert_name}
                                                        onChange={handleNewExpertChange}
                                                    />
                                                </div>

                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Rank</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="rank"
                                                        placeholder="AIR"
                                                        value={newExpert.rank}
                                                        onChange={handleNewExpertChange}
                                                    />
                                                </div>

                                                {/* New Expert File Upload */}
                                                <div className="col-sm-12 mb-3">
                                                    <label className="profile_text_2 mb-3">Image</label>
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="common-input common-input--md dash_borad_input_1"
                                                            placeholder={selectedNewExpertFile ? selectedNewExpertFile.name : "No file selected"}
                                                            readOnly
                                                        />
                                                        <label htmlFor="newExpertFile" className="media-btn" style={{ cursor: "pointer" }}>
                                                            <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                            <span>Media</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="newExpertFile"
                                                            style={{ display: "none" }}
                                                            onChange={handleNewExpertFileChange}
                                                            accept="image/*"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-end">
                                                    <button onClick={saveNewExpert} className="btn btn_cousre bg-main-btn text-white">
                                                        Save
                                                    </button>
                                                </div>

                                                <hr />

                                                <label className="profile_text_2 mb-3 learn-title2">Existing Experts</label>
                                                {showExpert.map((expert, index) => (
                                                    <div key={index} className="mb-4">
                                                        <div className="col-sm-12 mb-4">
                                                            <input
                                                                className="common-input common-input--md dash_borad_input_1"
                                                                type="text"
                                                                name="name"
                                                                value={expert.name}
                                                                onChange={(e) => handleExistingExpertChange(index, e)}
                                                                disabled={!expert.isEditing}
                                                            />
                                                        </div>

                                                        <div className="col-sm-12 mb-4">
                                                            <input
                                                                className="common-input common-input--md dash_borad_input_1"
                                                                type="text"
                                                                name="rank"
                                                                value={expert.rank}
                                                                onChange={(e) => handleExistingExpertChange(index, e)}
                                                                disabled={!expert.isEditing}
                                                            />
                                                        </div>

                                                        <div className="col-sm-12 mb-3">
                                                            <img
                                                                src={`${Image_Base_Url}${expert.media_image_path}`}
                                                                alt="Expert"
                                                                className="img-fluid rounded"
                                                                style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px" }}
                                                            />
                                                            {expert.isEditing && (
                                                                <input
                                                                    type="file"
                                                                    onChange={(e) => handleExistingExpertFileChange(index, e)}
                                                                    accept="image/*"
                                                                />
                                                            )}
                                                        </div>

                                                        <div className="d-flex justify-content-end">
                                                            <button
                                                                onClick={() => (expert.isEditing ? saveExistingExpert(index) : toggleEditMode(index))}
                                                                className="btn btn_cousre bg-main-btn text-white"
                                                            >
                                                                {expert.isEditing ? "Save" : "Edit"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* 10+ Years Legacy Data Section */}
                                {/* <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3 learn-title2">10+ Years Legacy Data</label>

                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Title</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="title"
                                                        placeholder="title"
                                                        value={legacyData.title}
                                                        onChange={handleInputChange3}
                                                    />
                                                </div>

                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Name</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="name"
                                                        placeholder="Name"
                                                        value={legacyData.name}
                                                        onChange={handleInputChange3}
                                                    />
                                                </div>

                                              
                                                <div className="col-sm-12 mb-3">
                                                    <label className="profile_text_2 mb-3">Image</label>
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="common-input common-input--md dash_borad_input_1"
                                                            placeholder={selectedLegacyFile ? selectedLegacyFile.name : "No file selected"}
                                                            readOnly
                                                        />
                                                        <label htmlFor="legacyFile" className="media-btn" style={{ cursor: "pointer" }}>
                                                            <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                            <span>Media</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            id="legacyFile"
                                                            style={{ display: "none" }}
                                                            onChange={handleLegacyFileChange}
                                                            accept="image/*"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-end">
                                                    <button onClick={saveLegacy} className="btn btn_cousre bg-main-btn text-white">
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}


                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3 learn-title2">10+ Years Legacy Data</label>

                                                {/* New Legacy Form */}
                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Title</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="title"
                                                        placeholder="Title"
                                                        value={newLegacy.title}
                                                        onChange={handleNewLegacyChange}
                                                    />
                                                </div>

                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Name</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        name="name"
                                                        placeholder="Name"
                                                        value={newLegacy.name}
                                                        onChange={handleNewLegacyChange}
                                                    />
                                                </div>

                                                {/* New Legacy File Upload */}
                                                <div className="col-sm-12 mb-3">
                                                    <label className="profile_text_2 mb-3">Image</label>
                                                    <div className="position-relative">
                                                        <input
                                                            type="file"
                                                            onChange={handleNewLegacyFileChange}
                                                            accept="image/*"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-end">
                                                    <button onClick={saveNewLegacy} className="btn btn_cousre bg-main-btn text-white">
                                                        Save
                                                    </button>
                                                </div>

                                                <hr />

                                                <label className="profile_text_2 mb-3 learn-title2">Existing Legacy Data</label>
                                                {legacyList.map((legacy, index) => (
                                                    <div key={index} className="mb-4">
                                                        {/* Title Input */}
                                                        <div className="col-sm-12 mb-3">
                                                            <input
                                                                className="common-input common-input--md dash_borad_input_1"
                                                                type="text"
                                                                name="description"
                                                                value={legacy.description ? legacy.description : ""}
                                                                onChange={(e) => handleExistingLegacyChange(index, e)}
                                                                disabled={!legacy.isEditing}
                                                            />
                                                        </div>

                                                        {/* Name Input */}
                                                        <div className="col-sm-12 mb-3">
                                                            <input
                                                                className="common-input common-input--md dash_borad_input_1"
                                                                type="text"
                                                                name="name"
                                                                value={legacy.name}
                                                                onChange={(e) => handleExistingLegacyChange(index, e)}
                                                                disabled={!legacy.isEditing}
                                                            />
                                                        </div>

                                                        {/* Image Preview & File Upload */}
                                                        <div className="col-sm-12 mb-3">
                                                            {legacy.image ? (
                                                                // Show selected file preview before saving
                                                                <img
                                                                    src={legacy.image}
                                                                    alt="Preview"
                                                                    className="img-fluid rounded"
                                                                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                                                />
                                                            ) : legacy.media_image_path ? (
                                                                // Show existing image if no new image selected
                                                                <img
                                                                    src={`${Image_Base_Url}${legacy.media_image_path}`}
                                                                    alt="Legacy"
                                                                    className="img-fluid rounded"
                                                                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                                                />
                                                            ) : (
                                                                // Show placeholder if no image exists
                                                                <input type="text" className="common-input" placeholder="No file selected" readOnly />
                                                            )}

                                                            {/* Show Choose File Input when Editing */}
                                                            {legacy.isEditing && (
                                                                <div className="position-relative mt-2">
                                                                    <label htmlFor={`legacyFile-${index}`} className="media-btn" style={{ cursor: "pointer" }}>
                                                                        <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                                        <span>Choose File</span>
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        id={`legacyFile-${index}`}
                                                                        style={{ display: "none" }}
                                                                        onChange={(e) => handleExistingLegacyFileChange(index, e)}
                                                                        accept="image/*"
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Save / Edit Button */}
                                                        <div className="d-flex justify-content-end">
                                                            <button
                                                                onClick={() => (legacy.isEditing ? saveExistingLegacy(index) : toggleEditLegacy(index))}
                                                                className="btn btn_cousre bg-main-btn text-white"
                                                            >
                                                                {legacy.isEditing ? "Save" : "Edit"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3 learn-title2">Lets Evolve The Paradigms</label>
                                                <div className="col-sm-12">
                                                    <label className="profile_text_2 mb-3">Description</label>
                                                    <input
                                                        className="common-input common-input--md dash_borad_input_1"
                                                        type="text"
                                                        description={description}
                                                        placeholder="Description"
                                                        value={description}
                                                        onChange={handleInputDescription}
                                                    />
                                                </div>



                                                <button onClick={saveDescription} className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20 mt-5" style={{ float: "right" }}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <label className="profile_text_2 mb-3 learn-title2">Find the Center</label>

                                        {/* Category */}
                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3">Add Find the Center Category</label>
                                                <input
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    type="text"
                                                    placeholder="Add Find the Center Category"
                                                    value={category}
                                                    onChange={(e) => setCategory(e.target.value)}
                                                />
                                                <button
                                                    onClick={handleSaveCategory}
                                                    className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20 mt-2"
                                                    style={{ float: 'right' }}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>

                                        <h6 className="mt-4 mb-2">Existing Categories</h6>
                                        {categories.map((cat, index) => (
                                            <div key={cat.id} className="mb-3 border rounded p-3">
                                                <input
                                                    className="form-control mb-2"
                                                    type="text"
                                                    value={cat.categoty_name}
                                                    disabled={!cat.isEditing}
                                                    onChange={(e) => handleEditInputChange(index, e.target.value)}
                                                />
                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white"

                                                    onClick={() =>
                                                        cat.isEditing ? saveExistingCategory(index) : toggleEditMode1(index)
                                                    }
                                                >
                                                    {cat.isEditing ? 'Save' : 'Edit'}
                                                </button>

                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white ms-3"

                                                    onClick={() =>
                                                        deleteExistingCategory(index)
                                                    }
                                                >
                                                    {'Delete'}
                                                </button>
                                            </div>
                                        ))}

                                        {/* Board */}
                                        <div className="row px-0 px-sm-3 mt-4">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3">Add Find the Center Board</label>
                                                <input
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    type="text"
                                                    placeholder="Add Find the Center Board"
                                                    value={board}
                                                    onChange={(e) => setBoard(e.target.value)}
                                                />
                                                <button
                                                    onClick={handleSaveBoard}
                                                    className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20 mt-2"
                                                    style={{ float: 'right' }}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>

                                        <h6 className="mt-4 mb-2">Existing Boards</h6>
                                        {boards.map((b, index) => (
                                            <div key={b.id} className="mb-3 border rounded p-3">
                                                <input
                                                    className="form-control mb-2"
                                                    type="text"
                                                    value={b.board_name}
                                                    disabled={!b.isEditing}
                                                    onChange={(e) => handleEditInputChangeBoard(index, e.target.value)}
                                                />
                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white"
                                                    onClick={() => b.isEditing ? saveBoard(index) : toggleEditModeBoard(index)}
                                                >
                                                    {b.isEditing ? 'Save' : 'Edit'}
                                                </button>

                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white ms-3"
                                                    onClick={() => deleteBoard(index)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        ))}


                                        {/* Standard */}
                                        <div className="row px-0 px-sm-3 mt-4">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3">Add Find the Center Standard</label>
                                                <input
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    type="text"
                                                    placeholder="Add Find the Center Standard"
                                                    value={standard}
                                                    onChange={(e) => setStandard(e.target.value)}
                                                />
                                                <button
                                                    onClick={handleSaveStandard}
                                                    className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20 mt-2"
                                                    style={{ float: 'right' }}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>

                                        <h6 className="mt-4 mb-2">Existing Standards</h6>
                                        {standards.map((item, index) => (
                                            <div key={item.id} className="mb-3 border rounded p-3">
                                                <input
                                                    className="form-control mb-2"
                                                    type="text"
                                                    value={item.standards_name}
                                                    disabled={!item.isEditing}
                                                    onChange={(e) => handleEditInputChangeStandard(index, e.target.value)}
                                                />
                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white"
                                                    onClick={() => item.isEditing ? saveStandard(index) : toggleEditModeStandard(index)}
                                                >
                                                    {item.isEditing ? 'Save' : 'Edit'}
                                                </button>
                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white ms-3"
                                                    onClick={() => deleteStandard(index)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        ))}


                                        {/* City */}
                                        <div className="row px-0 px-sm-3 mt-4">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3">Find the Center City</label>
                                                <input
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    type="text"
                                                    placeholder="Add Find the Center City"
                                                    value={city}
                                                    onChange={(e) => setCity(e.target.value)}
                                                />
                                                <button
                                                    onClick={handleSaveCity}
                                                    className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20 mt-2"
                                                    style={{ float: 'right' }}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>

                                        <h6 className="mt-4 mb-2">Existing Cities</h6>
                                        {cities.map((item, index) => (
                                            <div key={item.id} className="mb-3 border rounded p-3">
                                                <input
                                                    className="form-control mb-2"
                                                    type="text"
                                                    value={item.city_name}
                                                    disabled={!item.isEditing}
                                                    onChange={(e) => handleEditInputChangeCity(index, e.target.value)}
                                                />
                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white"
                                                    onClick={() => item.isEditing ? saveCity(index) : toggleEditModeCity(index)}
                                                >
                                                    {item.isEditing ? 'Save' : 'Edit'}
                                                </button>
                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white ms-3"
                                                    onClick={() => deleteCity(index)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        ))}


                                        {/* Area */}
                                        <div className="row px-0 px-sm-3 mt-4">
                                            <div className="col-sm-12">
                                                <label className="profile_text_2 mb-3">Find the Center Area</label>
                                                <input
                                                    className="common-input common-input--md dash_borad_input_1"
                                                    type="text"
                                                    placeholder="Add Find the Center Area"
                                                    value={area}
                                                    onChange={(e) => setArea(e.target.value)}
                                                />
                                                <button
                                                    onClick={handleSaveArea}
                                                    className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20 mt-2"
                                                    style={{ float: 'right' }}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>

                                        <h6 className="mt-4 mb-2">Existing Areas</h6>
                                        {areas.map((item, index) => (
                                            <div key={item.id} className="mb-3 border rounded p-3">
                                                <input
                                                    className="form-control mb-2"
                                                    type="text"
                                                    value={item.area_name}
                                                    disabled={!item.isEditing}
                                                    onChange={(e) => handleEditInputChangeArea(index, e.target.value)}
                                                />
                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white"
                                                    onClick={() => item.isEditing ? saveArea(index) : toggleEditModeArea(index)}
                                                >
                                                    {item.isEditing ? 'Save' : 'Edit'}
                                                </button>
                                                <button
                                                    className="btn btn_cousre bg-main-btn text-white ms-3"
                                                    onClick={() => deleteArea(index)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        ))}

                                    </div>
                                </div>

                                {/* </div> */}

                                <div className="row px-5 pb-4">
                                    <div className="dashboard_sub_card">
                                        <label className="profile_text_2 mb-3 learn-title2">Find the Center</label>

                                        <div className="row px-0 px-sm-3">
                                            <div className="col-sm-12">
                                                <section className="py-4">
                                                    <div className="row g-3">
                                                        {/* Category */}
                                                        <div className="col-md-6">
                                                            <label className="form-label">Category</label>
                                                            <select
                                                                className="form-select"
                                                                value={selectedCategory}
                                                                onChange={(e) => setSelectedCategory(e.target.value)}
                                                            >
                                                                <option value="">Select Category</option>
                                                                {categories.map((cat) => (
                                                                    <option key={cat.id} value={cat.categoty_name}>
                                                                        {cat.categoty_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Board */}
                                                        <div className="col-md-6">
                                                            <label className="form-label">Board</label>
                                                            <select
                                                                className="form-select"
                                                                value={selectedBoard}
                                                                onChange={(e) => setSelectedBoard(e.target.value)}
                                                            >
                                                                <option value="">Select Board</option>
                                                                {boards.map((b) => (
                                                                    <option key={b.id} value={b.board_name}>
                                                                        {b.board_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Standard */}
                                                        <div className="col-md-6">
                                                            <label className="form-label">Standard</label>
                                                            <select
                                                                className="form-select"
                                                                value={selectedStandard}
                                                                onChange={(e) => setSelectedStandard(e.target.value)}
                                                            >
                                                                <option value="">Select Standard</option>
                                                                {standards.map((s) => (
                                                                    <option key={s.id} value={s.standards_name}>
                                                                        {s.standards_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-md-6">
                                                            <label className="form-label">City</label>
                                                            <select
                                                                className="form-select"
                                                                value={selectedCity}
                                                                onChange={(e) => setSelectedCity(e.target.value)}
                                                            >
                                                                <option value="">Select City</option>
                                                                {cities.map((c) => (
                                                                    <option key={c.id} value={c.city_name}>
                                                                        {c.city_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Area */}
                                                        <div className="col-md-6">
                                                            <label className="form-label">Area</label>
                                                            <select
                                                                className="form-select"
                                                                value={selectedArea}
                                                                onChange={(e) => setSelectedArea(e.target.value)}
                                                            >
                                                                <option value="">Select Area</option>
                                                                {areas.map((a) => (
                                                                    <option key={a.id} value={a.area_name}>
                                                                        {a.area_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Email */}
                                                        <div className="col-md-6">
                                                            <label className="form-label">Email Address</label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                placeholder="Enter your email"
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                            />
                                                        </div>

                                                        {/* Place Name */}
                                                        <div className="col-md-6">
                                                            <label className="form-label">Place Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter place name"
                                                                value={placeName}
                                                                onChange={(e) => setPlaceName(e.target.value)}
                                                            />
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-md-6">
                                                            <label className="form-label">Mobile</label>
                                                            <input
                                                                type="tel"
                                                                className="form-control"
                                                                placeholder="Enter mobile number"
                                                                value={mobile}
                                                                onChange={(e) => setMobile(e.target.value)}
                                                            />
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-md-12">
                                                            <label className="form-label">Address</label>
                                                            <textarea
                                                                className="form-control"
                                                                rows="3"
                                                                placeholder="Enter address"
                                                                value={address}
                                                                onChange={(e) => setAddress(e.target.value)}
                                                            ></textarea>
                                                        </div>

                                                        {/* Submit Button */}
                                                        <div className="col-md-3 ">
                                                            <button
                                                                type="submit"
                                                                className="btn btn_cousre bg-main-btn text-white px-4 py-2 fw-bold"
                                                                onClick={saveFinderData}
                                                            >
                                                                Submit <i className="far fa-paper-plane ms-2"></i>
                                                            </button>
                                                        </div>

                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </div>




                            </div>


                        </div>



                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default InstituteProfile;
